import { userFilters } from "@features/onboarding/utility-setup/types";
import { complaintKeyFactory } from "./keyFactories/cx/complaintKeyFactory";
import { consumerKeyFactory } from "./keyFactories/cx/consumerKeyFactory";
import { disconnectKeyFactory } from "./keyFactories/cx/disconnectionRequestKeyFactory";
import { nscKeyFactory } from "./keyFactories/cx/nscKeyFactory";
import { outstandingKeyFactory } from "./keyFactories/cx/outstandingKeyFactory";
import { paymentsKeyFactory } from "./keyFactories/cx/paymentsKeyFactory";
import { reconnectKeyFactory } from "./keyFactories/cx/reconnectionRequestKeyFactory";
import { serviceRequestKeyFactory } from "./keyFactories/cx/serviceKeyFactory";
import { transferKeyFactory } from "./keyFactories/cx/transferKeyFactory";
import { settingsKeyFactory } from "./keyFactories/mx/settingsKeyFactory";
import { validationsKeyFactory } from "./keyFactories/mx/validationsKeyFactory";
import { planTarrifKeyFactory } from "./keyFactories/onboarding/Plan-Tarrif/PlanTarrifKeyFactory";
import { coreSettingsKeyFactory } from "./keyFactories/onboarding/core-settings/CoreSettingsFactory";
import { serviceAreaKeyFactory } from "./keyFactories/onboarding/service-area/ServiceAreaFactoryKey";
import { historyKeyFactory } from "./keyFactories/ux/hisoryKeyFactory";
import { templateKeyFactory } from "./keyFactories/ux/templateKeyFactory";
import { workflowKeyFactory } from "./keyFactories/ux/workflowKeyFactory";

import { sopFilters } from "@features/wx/master/types";
import { facilitiesKeyFactory } from "./keyFactories/ax/assetRegistry.tsx/facilities";
import { serviceAndMangement } from "./keyFactories/ax/serv-and-mgnt/system-alert";
import { paymentKeyFactory } from "./keyFactories/ix/paymentKeyFactory";
import { listsKeyFactory } from "./keyFactories/ux/listsKeyFactory";
import { messagingKeyFactory } from "./keyFactories/ux/messagingKeyFactory";
import { subscriptionKeyFactory } from "./keyFactories/onboarding/subscriptions/subscriptionKeyFactory";
export type EntityType =
  | "user"
  | "organization"
  | "meter"
  | "disconnectionRequests"
  | "reconnectionRequests"
  | "transferRequests"
  | "consumer"
  | "creditNote"
  | "outstanding"
  | "workorder"
  | "billing"
  | "notification"
  | "activity"
  | "utility"
  | "plan"
  | "tariff"
  | "serviceCategory"
  | "serviceSubCategory"
  | "complaintCategory"
  | "complaintSubCategory"
  | "priority"
  | "template"
  | "facilityType"
  | "availability"
  | "serviceConfig"
  | "failures"
  | "complaintConfig"
  | "severity"
  | "selfService"
  | "frequency"
  | "meterCycle"
  | "disconnectionRequests"
  | "disconnectionRequestDetails"
  | "disconnectionRequestHistory"
  | "complaints"
  | "complaintConfigurations"
  | "complaintStatusChoices"
  | "complaintFilterOptions"
  | "dashboard"
  | "nsc"
  | "cxonboarding"
  | "meter"
  | "route"
  | "complaintFilterOptions"
  | "communicationOverview"
  | "communicationListOverview"
  | "communicationChannelStats"
  | "communicationChannelPerformance"
  | "communicationchannelStat"
  | "communicationWorkflowPerformance"
  | "communicationWorkflowStats"
  | "communicationRecipientType"
  | "communicationRecipientList"
  | "communicationChannelType"
  | "communicationTemplates"
  | "communicationTemplatesUse"
  | "communicationContactList"
  | "communicationCategoryConf"
  | "communicationTerritoryConfig"
  | "communicationContactsWithTerritoryFilter"
  | "communicationContactsWithCategoryFilter"
  | "communicationStaticAllContacts"
  | "communicationWorkflow"
  | "communicationWorkflowRun"
  | "communicationWorkflowNotifications"
  | "communicationWorkflowStat"
  | "communicationNotificationHistory"
  | "communicationNotificationDetails"
  | "communicationContactPreview"
  | "communicationPlaceHolders"
  | "networkType"
  | "dispatcher"
  | "communicationPlaceHoldersGroups"
  | "communicationEventType"
  | "communicationHistoryFilter"
  | "communicationRecipientListEdit"
  | "communicationWorkflowDraft"
  | "communicationWorkflowActive"
  | "communicationWorkflowAll"
  | "wxPending"
  | "wxAssigned"
  | "wxComplete"
  | "wxHistory"
  | "wxSODetails"
  | "wxServiceProcedures"
  | "wxActiveServiceProcedures"
  | "wxServiceProceduresByType"
  | "wxServiceProceduresByAssociation"
  | "wxServiceProcedureDetail"
  | "wxConsumerList"
  | "wxMeterList"
  | "wxFieldForceRecommend"
  | "wxRecommendation"
  | "wxSubTypes"
  | "wxTypes"
  | "wxSlaRules"
  | "wxTaxRates"
  | "certifications"
  | "wxSkills"
  | "wxRoles"
  | "wxRates"
  | "wxServiceProcedureSummary"
  | "wxSopDetails"
  | "wxPPEEquipment"
  | "networks"
  | "wxSafetyPackage"
  | "wxSafetyProtocol"
  | "wxOperationTypes"
  | "communicationWorkflowAll"
  | "serviceOrders"
  | "consumerStatus"
  | "consumerCategory"
  | "paymentHistory"
  | "manufacturer"
  | "utilityServices"
  | "serviceRequests"
  | "paymentHistory"
  | "rateTypes"
  | "basisTypes"
  | "serviceCharges"
  | "rateNames"
  | "rateList"
  | "billFrequency"
  | "taxType"
  | "category"
  | "subCategory"
  | "recentlyUpdatedRates"
  | "recentlyUpdatedPlans"
  | "planKPIs"
  | "rateDetail"
  | "planList"
  | "meterSchedule"
  | "meterSchedule"
  | "fieldForce"
  | "payment"
  | "operationalSLA"
  | "serviceAssociations"
  | "sopEditDetails"
  | "sopReadings"
  | "sopMaterials"
  | "sopTasks"
  | "sopSubtypes"
  | "sopTypes"
  | "allUtilityService"
  | "systemAdminList"
  | "RolePermissionList"
  | "ContractList"
  | "operationalSLA"
  | "TerritoryView"
  | "territoryMapping"
  | "TerritoryStats"
  | "EntityTypes"
  | "territoryJson"
  | "configCode"
  | "operationalSLA"
  | "logs"
  | "settingTask"
  | "settingMaterial"
  | "settingReading"
  | "monthlySummary"
  | "territory-premise-stats"
  | "UserNames"
  | "planVersion"
  | "territoryCount"
  | "settingOperationType"
  | "UserNames"
  | "planVersion"
  | "territoryCount"
  | "settingOperationType"
  | "wxMasterActivityLogs"
  | "uxWorkflow"
  | "uxWorkflowRun"
  | "uxWorkflowPerformance"
  | "uxWorkflowStats"
  | "uxWorkflowStat"
  | "uxWorkflowNotifications"
  | "uxEventType"
  | "uxMessageTemplate"
  | "uxTemplate"
  | "uxTemplateUse"
  | "uxPlaceholderGroups"
  | "uxPlaceholders"
  | "uxTemplateCategory"
  | "communication"
  | "sessions"
  | "callPurpose"
  | "consumerSearch"
  | "consumerSearchWithExtraInfo"
  | "callStatus"
  | "summaryDashboard"
  | "allCallEntries"
  | "getConsumerBill"
  | "downloadBill"
  | "performance"
  | "EntityTypeNonPaginated"
  | "nscSettings"
  | "nscSettings"
  | "createdUserNames"
  | "settings"
  | "systemType"
  | "settings"
  | "facilities"
  | "assets"
  | "systemManagement"
  | "schedule"
  | "systemAlerts"
  | "serviceOrderHistory"
  | "sopTemplate"
  | "serviceOrderAssets"
  | "serviceOrderSystems"
  | "serviceOrderFacilities"
  | "serviceOrderNetworks"
  | "subscription";

export type ActionType =
  | "list"
  | "verifyEmail"
  | "planDetails"
  | "installments"
  | "paymentChannel"
  | "billTemplates"
  | "consumerDisconnect"
  | "reasons"
  | "payTypeChoices"
  | "plans"
  | "billApprove"
  | "documentUpdate"
  | "consumerRelationChoices"
  | "utilityConfig"
  | "categoryDropdown"
  | "subCategoryDropdown"
  | "complete"
  | "documentApprove"
  | "documentReject"
  | "approve"
  | "reconnectActivateConsumer"
  | "workflow"
  | "completeWorkflow"
  | "meterData"
  | "updateConsumerPlan"
  | "consumerSearch"
  | "consumerMetaData"
  | "receivedStatusChoices"
  | "latestBill"
  | "channelType"
  | "paymentAgreements"
  | "paymentAgreementDetail"
  | "paymentMethod"
  | "channelTemplates"
  | "details"
  | "profile"
  | "permission"
  | "services"
  | "tipsData"
  | "create"
  | "update"
  | "delete"
  | "search"
  | "status"
  | "filter"
  | "dashboard"
  | "history"
  | "acknowledge"
  | "hold"
  | "reject"
  | "resolve"
  | "updateStatus"
  | "stepSave"
  | "stepper"
  | "bulkSelection"
  | "actions"
  | "recentActivity"
  | "routeDetails"
  | "metersDetails"
  | "logs"
  | "meterSummaryDashboard"
  | "meterType"
  | "configuration"
  | "meterSummaryDashboardByRouteId"
  | "searchMeterRoute"
  | "activity"
  | "documents"
  | "notes"
  | "financialSummary"
  | "billingHistory"
  | "consumptionData"
  | "relationshipInsights"
  | "utilityConnections"
  | "connectionsHistory"
  | "serviceRequests"
  | "communications"
  | "meterReadings"
  | "complaints"
  | "serviceOrders"
  | "category"
  | "subCategory"
  | "meterSummaryDashboardByPremises"
  | "premises"
  | "subareas"
  | "routeData"
  | "metersCount"
  | "performanceDashboard"
  | "metadata"
  | "serviceOrders"
  | "pauseReadCycle"
  | "paymentHistory"
  | "timeSlotChoices"
  | "consumerBill"
  | "billGeneration"
  | "billUpdate"
  | "transactionStatusChoices"
  | "noteTypeChoices"
  | "billData"
  | "frequency"
  | "weekDays"
  | "activeUtility"
  | "months"
  | "months"
  | "summary"
  | "getAssignments"
  | "getDetails"
  | "getTransactions"
  | "getActivityLogs"
  | "getAllCertificates"
  | "updateFieldForce"
  | "getAllSkills"
  | "getAllAvailability"
  | "getChannel"
  | "updateChannelStatus"
  | "createChannel"
  | "updateChannel"
  | "getMode"
  | "updateModeStatus"
  | "getDisconnectionReasons"
  | "createDisconnectionReason"
  | "updateDisconnectionReason"
  | "deleteDisconnectionReason"
  | "getReconnectionReasons"
  | "getTransferTypes"
  | "getAllFieldTypes"
  | "createMode"
  | "updateMode"
  | "getSkills"
  | "getCertificates"
  | "getAreas"
  | "auditTrail"
  | "work-order-details"
  | "allocationHistory"
  | "detail"
  | "draft"
  | "active"
  | "all"
  | "filtered"
  | "published"
  | "legacyFilter"
  | "callPurpose"
  | "callStatus"
  | "callEntry"
  | "consumerSearch"
  | "summaryDashboard"
  | "consumerWeeklyReport"
  | "getAllPaymentFields"
  | "deleteMode"
  | "deleteChannel"
  | "communicationHistory"
  | "getResponseTimeConfiguration"
  | "getAllAddressComponent"
  | "documentType"
  | "consumerExport"
  | "paymentExport"
  | "outstandingExport"
  | "serviceRequestsExport"
  | "complaintsExport"
  | "disconnectionRequestsExport"
  | "transferRequestsExport"
  | "choices"
  | "performance"
  | "getAllManufacturer"
  | "getCountry"
  | "getAssetType"
  | "getManufacturerById"
  | "getManufacturerSummary"
  | "getAllSystemType"
  | "getAllSystemTypeParameter"
  | "searchSystemType"
  | "deleteSystemType"
  | "getAllAssets"
  | "getAllAssetStatus"
  | "alerts"
  | "compliance"
  | "complianceHistory"
  | "getFacilities"
  | "getChoices"
  | "getAllSystems"
  | "getDashboardData"
  | "getAllUserInfo"
  | "getSystemDataById"
  | "getAllSystemTabDataById"
  | "getSystemAssetTabDataById"
  | "getAllUtilityServices"
  | "getAllCriticality"
  | "getAllTabsDashboardData"
  | "getAllSchedules"
  | "getAllSOPs"
  | "getAllFacilities"
  | "getAllNetworks"
  | "recommendationsDashboardKpis"
  | "recommendations"
  | "getScheduleById"
  | "getAllScheduleAssets"
  | "getAllScheduleServiceOrderHistory"
  | "getAllServiceOrder"
  | "getSystemComplianceTabDataById"
  | "getSystemComplianceHistoryTabDataById"
  | "getSystemConditionAndRiskById"
  | "getConditionHistory"
  | "getSystemType"
  | "getAllEnergyConsumptionHistory"
  | "operationType"
  | "validationRules"
  | "meterRunHistory"
  | "getPerformanceDashboard"
  | "getAllMeterCycleForMoveRoutes"
  | "getRules"
  | "getPremise"
  | "areaList"
  | "subAreaList"
  | "getScheduleReview"
  | "getMeterScheduleList"
  | "getMeterScheduleSummary"
  | "getMeterScheduleDetails"
  | "meterRunHistoryForSchedule"
  | "getAllReadCycle"
  | "meterHistory"
  | "assignedRoutes"
  | "getPremiseBySearch";

export type ModuleType =
  | "auth"
  | "onboarding"
  | "cx"
  | "bx"
  | "ax"
  | "mx"
  | "wx"
  | "rx"
  | "ux"
  | "global"
  | "callCenter"
  | "ix";

// Query key factory following entity-first pattern
export class QueryKeyFactory {
  // Global shared data (cross-module)
  static global = {
    user: {
      profile: (): [EntityType, ActionType] => ["user", "profile"],
      permission: (): [EntityType, ActionType] => ["user", "permission"],

      details: (userId: string): [EntityType, ActionType, string] => [
        "user",
        "details",
        userId,
      ],
    },
    utilities: {
      selected: () => ["global", "utilities", "selected"],
    },

    organization: {
      settings: (): [EntityType, ActionType] => ["organization", "profile"],
      details: (orgId: string): [EntityType, ActionType, string] => [
        "organization",
        "details",
        orgId,
      ],
    },

    meter: {
      list: (filters?: any): [EntityType, ActionType, any?] => [
        "meter",
        "list",
        filters,
      ],
      details: (meterId: string): [EntityType, ActionType, string] => [
        "meter",
        "details",
        meterId,
      ],
      consumerData: (consumerId: string): [EntityType, "consumer", string] => [
        "meter",
        "consumer",
        consumerId,
      ],
    },

    workorder: {
      list: (filters?: any): [EntityType, ActionType, any?] => [
        "workorder",
        "list",
        filters,
      ],
      details: (workorderId: string): [EntityType, ActionType, string] => [
        "workorder",
        "details",
        workorderId,
      ],
      sops: (): [EntityType, "sops"] => ["workorder", "sops"],
    },

    utility: {
      profile: (): [EntityType, ActionType] => ["utility", "profile"],
      settings: (): [EntityType, "settings"] => ["utility", "settings"],
      list: (): [EntityType, ActionType] => ["utility", "list"],
      services: (): [EntityType, ActionType] => ["utility", "list"],
      activeUtility: (): [EntityType, ActionType] => [
        "utility",
        "activeUtility",
      ],
    },
    onboarding: {
      configMapJson: (
        jsonType: string,
        configLevel: string,
        codeLevel
      ): [EntityType, ActionType, string, string, string] => [
        "organization",
        "list",
        jsonType,
        configLevel,
        codeLevel,
      ],
    },
  };

  // Module-specific data
  static module = {
    onboarding: {
      area: (): [ModuleType, "area"] => ["onboarding", "area"],
      dataTypes: (): [ModuleType, "dataTypes"] => ["onboarding", "dataTypes"],
      migrationModules: (): [ModuleType, "migration-modules"] => [
        "onboarding",
        "migration-modules",
      ],
      dashboard: (
        remoteUtilityId: string
      ): [ModuleType, "historyDashboard", ActionType, string] => [
        "onboarding",
        "historyDashboard",
        "summary",
        remoteUtilityId,
      ],
      dataTypesByModule: (
        moduleKey: number
      ): [ModuleType, "data-types-by-module", number] => [
        "onboarding",
        "data-types-by-module",
        moduleKey,
      ],
      templateDetail: (
        templateId: string
      ): [ModuleType, "templateDetail", string] => [
        "onboarding",
        "templateDetail",
        templateId,
      ],
      suggestions: (sessionId: string) => [
        "onboarding",
        "suggestions",
        sessionId,
      ],
      transformationPreview: (sessionId: string, sourceColumn: string) => [
        "onboarding",
        "transformation-preview",
        sessionId,
        sourceColumn,
      ],
      dataUpdationTypes: (
        categoryKey: string
      ): [ModuleType, "dataUpdationTypes", string] => [
        "onboarding",
        "dataUpdationTypes",
        categoryKey,
      ],

      dataHistory: (
        page?: number,
        limit?: number,
        search?: string
      ): [ModuleType, "dataHistory", number, number, string] => [
        "onboarding",
        "dataHistory",
        page || 1,
        limit || 10,
        search || "",
      ],

      categoryOptions: (
        utilityId: string,
        configLevel: string
      ): [ModuleType, "categoryOptions", string, string] =>
        ["onboarding", "categoryOptions", utilityId, configLevel] as const,
      planOptions: (utilityId: string): [ModuleType, "planOptions", string] =>
        ["onboarding", "planOptions", utilityId] as const,

      assetClassOptions: (
        utilityId: string
      ): [ModuleType, "assetClassOptions", string] =>
        ["onboarding", "assetClassOptions", utilityId] as const,

      assetTypeOptions: (
        utilityId: string
      ): [ModuleType, "assetTypeOptions", string] =>
        ["onboarding", "assetTypeOptions", utilityId] as const,

      systemTypeOptions: (
        utilityId: string
      ): [ModuleType, "systemTypeOptions", string] =>
        ["onboarding", "systemTypeOptions", utilityId] as const,

      facilityTypeOptions: (
        utilityId: string
      ): [ModuleType, "facilityTypeOptions", string] =>
        ["onboarding", "facilityTypeOptions", utilityId] as const,

      premiseOptions: (
        utilityId: string
      ): [ModuleType, "premiseOptions", string] =>
        ["onboarding", "premiseOptions", utilityId] as const,

      territoryZoneOptions: (
        utilityId: string
      ): [ModuleType, "territoryZoneOptions", string] =>
        ["onboarding", "territoryZoneOptions", utilityId] as const,

      // Inside QueryKeyFactory.module.ax (add if doesn't exist)
      ax: {
        manufacturerOptions: (
          utilityId: string,
          page: number,
          limit: number
        ): [ModuleType, "manufacturerOptions", string, number, number] =>
          ["ax", "manufacturerOptions", utilityId, page, limit] as const,

        depreciationMethodOptions: (): [
          ModuleType,
          "depreciationMethodOptions"
        ] => ["ax", "depreciationMethodOptions"] as const,

        networkTypeOptions: (): [ModuleType, "networkTypeOptions"] =>
          ["ax", "networkTypeOptions"] as const,

        facilityStatusOptions: (): [ModuleType, "facilityStatusOptions"] =>
          ["ax", "facilityStatusOptions"] as const,

        backupStatusOptions: (): [ModuleType, "backupStatusOptions"] =>
          ["ax", "backupStatusOptions"] as const,

        operationalHoursOptions: (): [ModuleType, "operationalHoursOptions"] =>
          ["ax", "operationalHoursOptions"] as const,
        operationalStatusOptions: (): [
          ModuleType,
          "operationalStatusOptions"
        ] => ["ax", "operationalStatusOptions"] as const,

        utilityServicesOptions: (
          utilityId: string
        ): [ModuleType, "utilityServicesOptions", string] =>
          ["ax", "utilityServicesOptions", utilityId] as const,

        depreciationScheduleOptions: (): [
          ModuleType,
          "depreciationScheduleOptions"
        ] => ["ax", "depreciationScheduleOptions"] as const,
      },

      validationSummary: (uploadId: string) => [
        "onboarding",
        "validationSummary",
        uploadId,
      ],

      meterTypeOptions: (): [ModuleType, "meterTypeOptions"] => [
        "onboarding",
        "meterTypeOptions",
      ],

      meterManufacturerOptions: (
        remoteUtilityId: string
      ): [ModuleType, "meterManufacturerOptions", string] => [
        "onboarding",
        "meterManufacturerOptions",
        remoteUtilityId,
      ],

      meterModelOptions: (
        remoteUtilityId: string
      ): [ModuleType, "meterModelOptions", string] => [
        "onboarding",
        "meterModelOptions",
        remoteUtilityId,
      ],

      utilityServicesOptions: (
        utilityId: string
      ): [ModuleType, "utilityServicesOptions", string] => [
        "onboarding",
        "utilityServicesOptions",
        utilityId,
      ],

      consumerStatusOptions: (
        remoteUtilityId: string
      ): [ModuleType, "consumerStatusOptions", string] => [
        "onboarding",
        "consumerStatusOptions",
        remoteUtilityId,
      ],

      systemStatusOptions: (
        remoteUtilityId: string
      ): [ModuleType, "systemStatusOptions", string] => [
        "onboarding",
        "systemStatusOptions",
        remoteUtilityId,
      ],

      savedTemplates: (
        page: number,
        limit: number,
        search: string
      ): [ModuleType, "savedTemplates", number, number, string] =>
        ["onboarding", "savedTemplates", page, limit, search] as const,

      subArea: (codeList: any): [ModuleType, "subArea", any] => [
        "onboarding",
        "subArea",
        codeList,
      ],
      progress: (): [ModuleType, "progress"] => ["onboarding", "progress"],
      steps: (): [ModuleType, "steps"] => ["onboarding", "steps"],

      orgSetup: (): [ModuleType, "orgSetup"] => ["onboarding", "orgSetup"],
      utilitySetup: (): [ModuleType, "utilitySetup"] => [
        "onboarding",
        "utilitySetup",
      ],
      utilitySetupProgres: (): [ModuleType, "utilitySetupProgres"] => [
        "onboarding",
        "utilitySetupProgres",
      ],
      utilityProgress: (): [ModuleType, "utilityProgress"] => [
        "onboarding",
        "utilityProgress",
      ],
      subscription: (): [ModuleType, "subscription"] => [
        "onboarding",
        "subscription",
      ],
      charts: (): [ModuleType, "charts"] => ["onboarding", "charts"],
      // Fixed query keys - remove 'as const' and use proper return types
      tenantDetail: (): [ModuleType, "tenant-detail"] => [
        "onboarding",
        "tenant-detail",
      ],
      validationErrors: (sessionId: string) => [
        "onboarding",
        "validationErrors",
        sessionId,
      ],

      errorDetail: (sessionId: string, errorType: string, field: string) => [
        "onboarding",
        "errorDetail",
        sessionId,
        errorType,
        field,
      ],
      dateFormats: (): [ModuleType, "dateFormats"] => [
        "onboarding",
        "dateFormats",
      ],
      currencies: (): [ModuleType, "currencies"] => [
        "onboarding",
        "currencies",
      ],
      timezones: (): [ModuleType, "timezones"] => ["onboarding", "timezones"],
      departments: (): [ModuleType, "departments"] => [
        "onboarding",
        "departments",
      ],
      leaveType: (): [ModuleType, "leaveType"] => ["onboarding", "leaveType"],
      users: (
        page?: number,
        limit?: number
      ): [ModuleType, "users", { page?: number; limit?: number }] => [
        "onboarding",
        "users",
        { page, limit },
      ],
      utilityDashboard: (): [ModuleType, "utilityDashboard"] => [
        "onboarding",
        "utilityDashboard",
      ],
      categories: (): [ModuleType, "categories"] => [
        "onboarding",
        "categories",
      ],
      utilityRevenue: (): [ModuleType, "utilityRevenue"] => [
        "onboarding",
        "utilityRevenue",
      ],
      customerService: (): [ModuleType, "customerService"] => [
        "onboarding",
        "customerService",
      ],

      workOrderService: (): [ModuleType, "workOrderService"] => [
        "onboarding",
        "workOrderService",
      ],
      userMgmtDashboard: (): [ModuleType, "userMgmtDashboard"] => [
        "onboarding",
        "userMgmtDashboard",
      ],
      userMgmtTable: (
        filters?: userFilters
      ): [ModuleType, EntityType, ActionType, userFilters] => [
        "onboarding",
        "consumer",
        "list",
        filters,
      ],
      auditLogs: (
        filters?: userFilters
      ): [ModuleType, EntityType, ActionType, userFilters] => [
        "onboarding",
        "logs",
        "list",
        filters,
      ],
      departmentOptions: (): [ModuleType, "departmentOptions"] => [
        "onboarding",
        "departmentOptions",
      ],
      roleOptions: (department?: string) => [
        "onboarding",
        "roleOptions",
        department || "all",
      ],

      holidayList: (
        monthYear: string
      ): [ModuleType, "holidayList", { monthYear: string }] => [
        "onboarding",
        "holidayList",
        { monthYear },
      ],
      workingHourList: (): [ModuleType, "workingHourList"] => [
        "onboarding",
        "workingHourList",
      ],
      userRolePermission: (): [ModuleType, "userRolePermission"] => [
        "onboarding",
        "userRolePermission",
      ],
      userRolePermissionAccess: (): [
        ModuleType,
        "userRolePermissionAccess"
      ] => ["onboarding", "userRolePermissionAccess"],

      entityTypesMaster: (): [ModuleType, "entityTypesMaster"] => [
        "onboarding",
        "entityTypesMaster",
      ],

      entityTypesTransaction: (): [ModuleType, "entityTypesTransaction"] => [
        "onboarding",
        "entityTypesTransaction",
      ],

      utilityServices: (): [ModuleType, "utilityServices"] => [
        "onboarding",
        "utilityServices",
      ],
      utilityServicesModulePercentage: (): [
        ModuleType,
        "utilityServicesModulePercentage"
      ] => ["onboarding", "utilityServicesModulePercentage"],

      dateFormatChoices: (): [ModuleType, "dateFormatChoices"] => [
        "onboarding",
        "dateFormatChoices",
      ],
      idTypes: (): [ModuleType, "idTypes"] => ["onboarding", "idTypes"],

      separatorChoices: (): [ModuleType, "separatorChoices"] => [
        "onboarding",
        "separatorChoices",
      ],
      numberFormats: (filter?: "master" | "transaction") => {
        if (filter === "master")
          return ["onboarding", "numberFormats", "is_master"];
        if (filter === "transaction")
          return ["onboarding", "numberFormats", "is_transaction"];
        return ["onboarding", "numberFormats"];
      },

      relationTabs: (
        sessionId: string
      ): [ModuleType, "relationTabs", string] => [
        "onboarding",
        "relationTabs",
        sessionId,
      ],

      groupedRelationData: (
        sessionId: string,
        tabName: string,
        filters?: any
      ): [ModuleType, "groupedRelationData", string, string, any] => [
        "onboarding",
        "groupedRelationData",
        sessionId,
        tabName,
        filters,
      ],

      nullRowsData: (
        sessionId: string,
        tabName: string,
        page: number,
        filters?: any
      ): [ModuleType, "nullRowsData", string, string, number, any] => [
        "onboarding",
        "nullRowsData",
        sessionId,
        tabName,
        page,
        filters,
      ],

      planTarrif: planTarrifKeyFactory,
      coreSettings: coreSettingsKeyFactory,
      serviceArea: serviceAreaKeyFactory,
      subscriptions: subscriptionKeyFactory,
    },

    mx: {
      deviceManagement: {
        route: (params: {
          premise: any;
        }): ["deviceManagement", "route", any] => [
          "deviceManagement",
          "route",
          params,
        ],
        premise: (params: {
          page: any;
          limit: any;
          search_data: any;
          exclude_code_name: any;
        }): ["deviceManagement", "premise", any] => [
          "deviceManagement",
          "premise",
          params,
        ],
        consumer: (params: {
          page: any;
          limit: any;
          status: any;
          searchData: any;
        }): ["deviceManagement", "consumer", any] => [
          "deviceManagement",
          "consumer",
          params,
        ],
        priority: (): [ModuleType, "deviceManagement", "priority"] => [
          "mx",
          "deviceManagement",
          "priority",
        ],
      },
      shared: {
        notesList: (
          type?: string,
          id?: string
        ): [ModuleType, EntityType, ActionType, string, string, string] => [
          "mx",
          "meter",
          "notes",
          "notes-list",
          id,
          type,
        ],
        activityLogList: (
          id?: string,
          type?: string
        ): [ModuleType, EntityType, ActionType, string, string, string] => [
          "mx",
          "meter",
          "getActivityLogs",
          "activity-log-list",
          id,
          type,
        ],
      },

      manufacturer: {
        manufacturers: (): [EntityType, "manufacturers"] => [
          "manufacturer",
          "manufacturers",
        ],
        meterManufacturers: (params: {
          remote_utility_id: any;
        }): [EntityType, "meterManufacturers", any] => [
          "manufacturer",
          "meterManufacturers",
          params,
        ],

        meterList: (params: {
          remote_utility_id: any;
          meter_model_id: string;
        }): [EntityType, "meterList", any] => [
          "manufacturer",
          "meterList",
          params,
        ],
        meterModels: (params: {
          remote_utility_id: any;
        }): [EntityType, "meterModels", any] => [
          "manufacturer",
          "meterModels",
          params,
        ],
        meterModelDetail: (params: {
          remote_utility_id: any;
          meter_model_id: string;
        }): [EntityType, "meterModelDetail", any] => [
          "manufacturer",
          "meterModelDetail",
          params,
        ],
        meterType: (): [EntityType, "meterType"] => ["meter", "meterType"],

        meterModelSummary: (params: {
          remote_utility_id: any;
        }): [EntityType, "meterModelSummary", any] => [
          "manufacturer",
          "meterModelSummary",
          params,
        ],
        manufacturerType: (params: {
          remote_utility_id: any;
          is_dropdown: any;
        }): [EntityType, "manufacturerType", any] => [
          "manufacturer",
          "manufacturerType",
          params,
        ],
      },
      meterSchedule: {
        create: (): [ModuleType, EntityType, ActionType] => [
          "mx",
          "meterSchedule",
          "create",
        ],
      },
      configMapJson: (
        jsonType: string,
        configLevel: string,
        codeLevel
      ): [EntityType, ActionType, string, string, string] => [
        "organization",
        "list",
        jsonType,
        configLevel,
        codeLevel,
      ],
      meter: {
        meterRead: (params: {
          remote_utility_id: any;
          meter_type: string;
          page: number;
          run_status: any;
          month_year: any;
        }): [EntityType, "meterRead", any] => ["meter", "meterRead", params],

        meterRun: (params: {
          remote_utility_id: any;
          meter_type: string;
          page: number;
          page_size: number;
        }): [EntityType, "meterRun", any] => ["meter", "meterRun", params],
        meterRunSummary: (params: {
          remote_utility_id: any;
          meter_type: string;
        }): [EntityType, "meterRunSummary", any] => [
          "meter",
          "meterRunSummary",
          params,
        ],
        meterStatus: (): [EntityType, "meterStatus"] => [
          "meter",
          "meterStatus",
        ],
        manualRunStatus: (): [EntityType, "manualRunStatus"] => [
          "meter",
          "manualRunStatus",
        ],
        dispatchStatus: (): [EntityType, "dispatchStatus"] => [
          "meter",
          "dispatchStatus",
        ],
        meterRunDetails: (params: {
          remote_utility_id: string;
          meter_type: string;
          meter_run_id: any;
        }): [EntityType, "meterRunDetails", any] => [
          "meter",
          "meterRunDetails",
          params,
        ],
        meterDispatch: (params: {
          remote_utility_id: string;
          meter_run_id: any;
          page: number;
          origin: string;
          run_status?: string;
          search?: string;
          meter_reader_id?: any;
        }): [EntityType, "meterDispatch", any] => [
          "meter",
          "meterDispatch",
          params,
        ],
        meterReaderList: (): [ModuleType, "meter-reader-list"] => [
          "mx",
          "meter-reader-list",
        ],
        assignConsumer: (params: {
          remote_utility_id: string;
          isActive: string;
        }): [EntityType, "assignConsumer", any] => [
          "meter",
          "assignConsumer",
          params,
        ],
        meterRunReadings: (params): [EntityType, "meterRunReading", any] => [
          "meter",
          "meterRunReading",
          params,
        ],
        meterValidationCompletion: (
          params
        ): [EntityType, "validationCompletionDetail", any] => [
          "meter",
          "validationCompletionDetail",
          params,
        ],
      },
      routesManagement: {
        auditTrail: (
          routeId: any,
          actionType
        ): [ModuleType, EntityType, ActionType, any, string] => [
          "mx",
          "route",
          "auditTrail",
          routeId,
          actionType,
        ],
        readingStatus: (): [
          ModuleType,
          "routesManagement",
          "readingStatus"
        ] => ["mx", "routesManagement", "readingStatus"],

        meterType: (): [ModuleType, "routesManagement", "meterType"] => [
          "mx",
          "routesManagement",
          "meterType",
        ],
        meterStatus: (): [ModuleType, "routesManagement", "meterStatus"] => [
          "mx",
          "routesManagement",
          "meterStatus",
        ],
        performanceDetails: (
          routeId: any,
          id?: number
        ): [ModuleType, "meter-route", string, any, number?] => [
          "mx",
          "meter-route",
          "performanceDetails",
          routeId,
          id,
        ],

        routeSummary: (): [ModuleType, EntityType, string] => [
          "mx",
          "route",
          "routeSummary",
        ],
        premise: (
          page?: any,
          area?: any,
          sub_area?: any,
          search_data?: any,
          exclude_code_name?: any
        ): [ModuleType, EntityType, string, any?, any?, any?, any?, any?] => [
          "mx",
          "route",
          "premise",
          page,
          area,
          sub_area,
          search_data,
          exclude_code_name,
        ],

        meters: (params: {
          premise: string | string[];
          page?: number;
          limit?: number;
        }): [
          ModuleType,
          EntityType,
          any,
          string | string[],
          number?,
          number?
        ] => [
          "mx",
          "route",
          "meters",
          params.premise,
          params.page,
          params.limit,
        ],
        meterCycle: (routeId: any): [ModuleType, EntityType, any, string] => [
          "mx",
          "route",
          "meterCycle",
          routeId,
        ],
        routePremise: (
          code_name: any
        ): [ModuleType, EntityType, any, string] => [
          "mx",
          "route",
          "routePremise",
          code_name,
        ],

        routeDashboard: (
          routeId: any
        ): [ModuleType, EntityType, any, string] => [
          "mx",
          "route",
          "routeDashboard",
          routeId,
        ],
        meterSummary: (premise: any): [ModuleType, EntityType, any, string] => [
          "mx",
          "route",
          "meterSummary",
          premise,
        ],

        area: (): [ModuleType, "area"] => ["mx", "area"],
        subArea: (codeList: any): [ModuleType, "subArea", any] => [
          "mx",
          "subArea",
          codeList,
        ],
        create: (): [ModuleType, EntityType, ActionType] => [
          "mx",
          "route",
          "create",
        ],
        routeData: (
          routeId?: any
        ): [ModuleType, EntityType, ActionType, any?] => [
          "mx",
          "route",
          "routeData",
          routeId,
        ],
        metersCount: (
          routeId?: any,
          page?: any,
          meter_type?: any,
          filter_status?: any,
          reading_status?: any,
          search_data?: any
        ): [
          ModuleType,
          EntityType,
          ActionType,
          any?,
          any?,
          any?,
          any?,
          any?,
          any?
        ] => [
          "mx",
          "route",
          "metersCount",
          routeId,
          page,
          meter_type,
          filter_status,
          reading_status,
          search_data,
        ],
        performanceDashboard: (
          routeId?: any
        ): [ModuleType, EntityType, ActionType, any?] => [
          "mx",
          "route",
          "performanceDashboard",
          routeId,
        ],
        meterSummaryDashboardByPremises: (
          premiseCode?: any[],
          category?: any[],
          subCategory?: any[],
          utilityService?: any[],
          meterType?: string
        ): [ModuleType, EntityType, ActionType, any[]?] => [
          "mx",
          "route",
          "meterSummaryDashboardByPremises",
          [premiseCode, category, subCategory, utilityService, meterType],
        ],
        category: (): [ModuleType, EntityType, ActionType] => [
          "mx",
          "route",
          "category",
        ],
        subCategory: (
          code_list: any[]
        ): [ModuleType, EntityType, ActionType, any[]] => [
          "mx",
          "route",
          "subCategory",
          code_list,
        ],
        list: (
          page?: number,
          search_data?: string,
          readType?: any,
          area?: any
        ): [
          ModuleType,
          EntityType,
          ActionType,
          number?,
          string?,
          any?,
          any?
        ] => ["mx", "route", "list", page, search_data, readType, area],
        premises: (
          premiseCode?: any[]
        ): [ModuleType, EntityType, ActionType, any[]?] => [
          "mx",
          "route",
          "premises",
          premiseCode,
        ],
      },
      readCycleManagement: {
        months: (): [ModuleType, EntityType, ActionType] => [
          "mx",
          "meterCycle",
          "months",
        ],
        weekDays: (): [ModuleType, EntityType, ActionType] => [
          "mx",
          "meterCycle",
          "weekDays",
        ],
        frequency: (): [ModuleType, EntityType, ActionType] => [
          "mx",
          "meterCycle",
          "frequency",
        ],
        validationRules: (): [ModuleType, EntityType, ActionType] => [
          "mx",
          "meterCycle",
          "validationRules",
        ],
        getPerformanceDashboard: (
          meterCycleId: any,
          runId?: number
        ): [ModuleType, EntityType, ActionType, any, number?] => [
          "mx",
          "meterCycle",
          "getPerformanceDashboard",
          meterCycleId,
          runId,
        ],
        meterRunHistory: (
          meterCycleId: any,
          page?: any,
          searchQuery?: any,
          status?: string
        ): [
          ModuleType,
          EntityType,
          ActionType,
          any,
          any?,
          any?,
          any?,
          string?
        ] => [
          "mx",
          "meterCycle",
          "meterRunHistory",
          meterCycleId,
          page,
          searchQuery,
          status,
        ],
        meterRunHistoryForSchedule: (
          scheduleId: any,
          page?: any,
          searchQuery?: any,
          status?: string
        ): [
          ModuleType,
          EntityType,
          ActionType,
          any,
          any?,
          any?,
          any?,
          string?
        ] => [
          "mx",
          "meterCycle",
          "meterRunHistoryForSchedule",
          scheduleId,
          page,
          searchQuery,
          status,
        ],
        getAllReadCycle: (
          status: string
        ): [ModuleType, EntityType, ActionType, string] => [
          "mx",
          "meterCycle",
          "getAllReadCycle",
          status,
        ],
        getAllMeterCycleForMoveRoutes: (
          routeIds?: any[],
          page?: number,
          search?: string,
          meterType?: string,
          status?: string,
          utilityId?: string
        ): [
          ModuleType,
          EntityType,
          ActionType,
          any[],
          number?,
          string?,
          string?,
          string?,
          string?
        ] => [
          "mx",
          "meterCycle",
          "getAllMeterCycleForMoveRoutes",
          routeIds,
          page,
          search,
          meterType,
          status,
          utilityId,
        ],
        getRules: (
          ruleType: number,
          utilityId: string,
          meterCycleId?: number
        ): [ModuleType, EntityType, ActionType, number, string, number?] => [
          "mx",
          "meterCycle",
          "getRules",
          ruleType,
          utilityId,
          meterCycleId,
        ],
        getPhotoMeterRules: (
          ruleType: number,
          utilityId: string,
          meterCycleId?: number
        ): [
          ModuleType,
          EntityType,
          "getPhotoMeterRules",
          number,
          string,
          number?
        ] => [
          "mx",
          "meterCycle",
          "getPhotoMeterRules",
          ruleType,
          utilityId,
          meterCycleId,
        ],
        getPremise: (
          code_name: any[],
          page?: number,
          limit?: number,
          area?: string,
          sub_area?: string
        ): [
          ModuleType,
          EntityType,
          ActionType,
          any[],
          number?,
          number?,
          string?,
          string?,
          string?
        ] => [
          "mx",
          "meterCycle",
          "getPremise",
          code_name,
          page,
          limit,
          area,
          sub_area,
        ],
        getPremiseBySearch: (
          code_name: any[],
          search_field: string,
          searchQuery?: string,
          page?: number,
          limit?: number,
        ): [
          ModuleType,
          EntityType,
          ActionType,
          any[],
          string,
          string?,
          number?,
          number?
        ] => [
          "mx",
          "meterCycle",
          "getPremiseBySearch",
          code_name,
          search_field,
          searchQuery,
          page,
          limit,
        ],
        areaList: (): [ModuleType, EntityType, ActionType] => [
          "mx",
          "meterCycle",
          "areaList",
        ],
        subAreaList: (
          areaList: string
        ): [ModuleType, EntityType, ActionType, string] => [
          "mx",
          "meterCycle",
          "subAreaList",
          areaList,
        ],
        getScheduleReview: (
          frequency?: string,
          startDate?: string,
          time?: string,
          endDate?: string
        ): [
          ModuleType,
          EntityType,
          ActionType,
          string?,
          string?,
          string?,
          string?
        ] => [
          "mx",
          "meterCycle",
          "getScheduleReview",
          frequency,
          startDate,
          time,
          endDate,
        ],
        getMeterScheduleList: (
          page?: number,
          limit?: number,
          frequency?: string,
          status?: string,
          readType?: string,
          startDate?: string,
          endDate?: string,
          search?: string
        ): [
          ModuleType,
          EntityType,
          ActionType,
          number?,
          number?,
          string?,
          string?,
          string?,
          string?,
          string?,
          string?
        ] => [
          "mx",
          "meterCycle",
          "getMeterScheduleList",
          page,
          limit,
          frequency,
          status,
          readType,
          startDate,
          endDate,
          search,
        ],
        getMeterScheduleSummary: (): [ModuleType, EntityType, ActionType] => [
          "mx",
          "meterCycle",
          "getMeterScheduleSummary",
        ],
        getMeterScheduleDetails: (
          scheduleId: string
        ): [ModuleType, EntityType, ActionType, string] => [
          "mx",
          "meterCycle",
          "getMeterScheduleDetails",
          scheduleId,
        ],
        pauseReadCycle: (
          meterCycleId: any
        ): [ModuleType, EntityType, ActionType, any] => [
          "mx",
          "meterCycle",
          "pauseReadCycle",
          meterCycleId,
        ],
        search: {
          searchMeterRoute: (): [ModuleType, EntityType, ActionType] => [
            "mx",
            "meterCycle",
            "searchMeterRoute",
          ],
        },
        meterType: (): [ModuleType, EntityType, ActionType] => [
          "mx",
          "meterCycle",
          "meterType",
        ],
        create: (): [ModuleType, EntityType, ActionType] => [
          "mx",
          "meterCycle",
          "create",
        ],
        list: (
          page?: number,
          search?: string,
          meterType?: string,
          status?: string,
          startDate?: string,
          endDate?: string
        ): [
          ModuleType,
          "meterCycle",
          number?,
          string?,
          string?,
          string?,
          string?,
          string?
        ] => [
          "mx",
          "meterCycle",
          page,
          search,
          meterType,
          status,
          startDate,
          endDate,
        ],
        routeDetails: (
          page?: any,
          cycleId?: number,
          utilityService?: any,
          readType?: any,
          searchQuery?: string
        ): [
          ModuleType,
          EntityType,
          ActionType,
          number,
          number?,
          any?,
          any?,
          string?
        ] => [
          "mx",
          "meterCycle",
          "routeDetails",
          page,
          cycleId,
          utilityService,
          readType,
          searchQuery,
        ],
        assignedRoutes: (
          page?: any,
          cycleId?: number,
          utilityService?: any,
          searchQuery?: string,
          isAssigned?: number
        ): [
          ModuleType,
          EntityType,
          ActionType,
          number,
          number?,
          any?,
          string?,
          number?
        ] => [
          "mx",
          "meterCycle",
          "assignedRoutes",
          page,
          cycleId,
          utilityService,
          searchQuery,
          isAssigned,
        ],
        metersDetails: (
          cycleId?: number,
          page?: number,
          searchQuery?: string
        ): [ModuleType, EntityType, ActionType, number, number, string] => [
          "mx",
          "meterCycle",
          "metersDetails",
          cycleId,
          page,
          searchQuery,
        ],
        searchMetersDetails: (
          cycleId: number,
          page: number,
          search_data: string
        ): [ModuleType, EntityType, ActionType, number, number, string] => [
          "mx",
          "meterCycle",
          "search",
          cycleId,
          page,
          search_data,
        ],
        auditTrail: (
          cycleId: number
        ): [ModuleType, EntityType, ActionType, number] => [
          "mx",
          "meterCycle",
          "logs",
          cycleId,
        ],
        meterSummaryDashboard: (
          cycleId: number
        ): [ModuleType, EntityType, ActionType, number] => [
          "mx",
          "meterCycle",
          "meterSummaryDashboard",
          cycleId,
        ],
        meterSummaryDashboardByRouteId: (
          routeId?: number[]
        ): [ModuleType, EntityType, ActionType, number[]?] => [
          "mx",
          "meterCycle",
          "meterSummaryDashboardByRouteId",
          routeId,
        ],
        summary: (): [ModuleType, EntityType, ActionType] => [
          "mx",
          "meterCycle",
          "dashboard",
        ],
        details: (
          cycleId: number
        ): [ModuleType, EntityType, ActionType, number] => [
          "mx",
          "meterCycle",
          "details",
          cycleId,
        ],
      },
      dashboard: {
        summary: () => ["mx", "dashboard", "summary"],
        validationDashboard: (params: {
          remote_utility_id: any;
        }): [EntityType, "validationDashboard", any] => [
          "dashboard",
          "validationDashboard",
          params,
        ],
        runWiseReadingValidationDashboard: (params: {
          remote_utility_id: any;
          meter_run_id: any;
        }): [EntityType, "runWiseReadingValidationDashboard", any] => [
          "dashboard",
          "runWiseReadingValidationDashboard",
          params,
        ],
        meterConditionDashboard: (params: {
          remote_utility_id: any;
        }): [EntityType, "meterConditionDashboard", any] => [
          "dashboard",
          "meterConditionDashboard",
          params,
        ],
        readCycleValidationStats: (params: {
          remote_utility_id: any;
        }): [EntityType, "readCycleValidationStats", any] => [
          "dashboard",
          "readCycleValidationStats",
          params,
        ],
        validationIssues: (params: {
          remote_utility_id: any;
        }): [EntityType, "validationIssues", any] => [
          "dashboard",
          "validationIssues",
          params,
        ],
        dailyValidationTrend: (params: {
          remote_utility_id: any;
        }): [EntityType, "dailyValidationTrend", any] => [
          "dashboard",
          "dailyValidationTrend",
          params,
        ],
        validationStats: (params: {
          remote_utility_id: any;
        }): [EntityType, "validationStats", any] => [
          "dashboard",
          "validationStats",
          params,
        ],
        meterRunList: (params: {
          remote_utility_id: any;
        }): [EntityType, "meterRunList", any] => [
          "dashboard",
          "meterRunList",
          params,
        ],
      },
      search: {
        meters: (searchField: string, searchData: string) => [
          "mx",
          "search",
          "meters",
          searchField,
          searchData,
        ],
      },
      device: {
        meterManufacturers: (params: {
          remote_utility_id: any;
        }): [EntityType, "meterManufacturers", any] => [
          "manufacturer",
          "meterManufacturers",
          params,
        ],
        detail: (meterId: number): [ModuleType, "device", number] => [
          "mx",
          "device",
          meterId,
        ],
        readings: (
          meterId: number,
          searchData: string,
          page: number,
          pageSize: number,
          fromDate?: string,
          toDate?: string,
          status?: string
        ): [
          ModuleType,
          ActionType,
          number,
          string,
          number,
          number,
          string?,
          string?,
          string?
        ] => [
          "mx",
          "list",
          meterId,
          searchData,
          page,
          pageSize,
          fromDate,
          toDate,
          status,
        ],
        consumption: (meterId): [ModuleType, "consumption", number] => [
          "mx",
          "consumption",
          meterId,
        ],
        deviceAllocationHistory: (
          meterNumber: number,
          deviceNo: number
        ): [ModuleType, ActionType, number, number] => [
          "mx",
          "allocationHistory",
          meterNumber,
          deviceNo,
        ],
        alerts: (meterId: number): [ModuleType, ActionType, number] => [
          "mx",
          "list",
          meterId,
        ],
        meterWorkorderInfo: (
          meterId: number
        ): [ModuleType, "work-order", number] => ["mx", "work-order", meterId],
        notes: (): [ModuleType, "notes"] => ["mx", "notes"],
      },
      inventory: (
        tab,
        page: number,
        limit: number,
        search?: string,
        meter_type?: any,
        manufacturer?: any
      ): [
        EntityType,
        "inventory",
        string,
        number,
        number,
        string,
        any,
        any
      ] => [
        "meter",
        "inventory",
        tab,
        page,
        limit,
        search,
        meter_type,
        manufacturer,
      ],
      choices: (choice: string): [ModuleType, ActionType, string] => [
        "mx",
        "filter",
        choice,
      ],

      serviceOrders: (
        page,
        status: string,
        searchData?: string,
        created_date_gte?: string,
        created_date_lte?: string,
        operation_type?: number
      ): [
        ModuleType,
        string,
        number,
        string,
        string,
        string,
        string,
        number
      ] => [
        "mx",
        "service-orders",
        page,
        status,
        searchData,
        created_date_gte,
        created_date_lte,
        operation_type,
      ],

      premises: (
        code: string
      ): [ModuleType, EntityType, ActionType, string] => [
        "mx",
        "route",
        "premises",
        code,
      ],
      subareas: (
        code: string
      ): [ModuleType, EntityType, ActionType, string] => [
        "mx",
        "route",
        "subareas",
        code,
      ],

      // meterAndConsumer: (
      //   page,
      //   search
      // ): [ModuleType, ActionType, number, string] => [
      //   "mx",
      //   "list",
      //   page,
      //   search,
      // ],
      meterAndConsumer: (
        page?: number,
        search?: string,
        operationType?: number,
        meterType?: string,
        service?: string,
        area?: string,
        subarea?: string
      ) => [
        "mx",
        "meter-and-consumer",
        page,
        search,
        operationType,
        meterType,
        service,
        area,
        subarea,
      ],
      meterModels: (
        isDistinctMeterMakes?: boolean,
        meterMake?: string,
        utilityService?: string
      ): [ModuleType, ActionType, boolean, string, string] => [
        "mx",
        "filter",
        isDistinctMeterMakes,
        meterMake,
        utilityService,
      ],
      sop: (operationType: number): [ModuleType, ActionType, number] => [
        "mx",
        "list",
        operationType,
      ],
      meterSummary: (): [ModuleType, ActionType] => ["mx", "list"],
      deviceMeters: (
        page: number,
        limit: number,
        searchData?: string,
        status?: string,
        meterType?: any
      ): [ModuleType, ActionType, number, number, string, string, any] => [
        "mx",
        "list",
        page,
        limit,
        searchData ?? "",
        status,
        meterType,
      ],
      useAllMeters: (params: {
        remoteUtilityId: string;
        page: number;
        limit: number;
        search?: string;
        status?: string;
        meter_type?: string;
        manufacturer?: string;
        model?: string;
        service?: string;
        area?: string;
        subarea?: string;
        premise?: string;
        reading_status?: string;
        date_from?: string;
        date_to?: string;
        operationType?: number;
      }): [ModuleType, ActionType, typeof params] => [
        "mx",
        "filter",
        params, // ✅ Include all params in cache key
      ],

      generateMeterNumber: (): [ModuleType, ActionType] => ["mx", "create"],
      meterSearchPrompt: (
        premise: string,
        product_code: string,
        searchData: string
      ): [ModuleType, ActionType, string, string, string] => [
        "mx",
        "list",
        premise,
        product_code,
        searchData,
      ],
      consumerProfile: (
        consumerNo: string
      ): [ModuleType, ActionType, string] => ["mx", "profile", consumerNo],
      meterDetail: (meterId: number): [ModuleType, "meterDetail", number] => [
        "mx",
        "meterDetail",
        meterId,
      ],
      logs: {
        activityLogs: (meterId): [ModuleType, ActionType, number] => [
          "mx",
          "list",
          meterId,
        ],
      },
      meterTypeCount: (): [ModuleType, "meter-type-count"] => [
        "mx",
        "meter-type-count",
      ],
      meterModel: (
        meterType: string,
        meterManufacturer: string
      ): [ModuleType, ActionType, string, string] => [
        "mx",
        "list",
        meterType,
        meterManufacturer,
      ],
      validations: validationsKeyFactory,
      settings: settingsKeyFactory,
      usedMetersList: (): [ModuleType, EntityType, ActionType, any] => [
        "mx",
        "meter",
        "list",
        "used-meters-list",
      ],
      reasonChoices: (): [ModuleType, ActionType, string] => [
        "mx",
        "filter",
        "reasonChoice",
      ],
    },
    ax: {
      dashboard: {
        getAllTabsDashboardData: (
          tabName: string,
          remoteUtilityId: string
        ): [ModuleType, EntityType, ActionType, string, string] => [
          "ax",
          "dashboard",
          "getAllTabsDashboardData",
          tabName,
          remoteUtilityId,
        ],

        financialData: (params: {
          remote_utility_id: any;
          date_filter: string;
        }): [EntityType, "financialData", any] => [
          "dashboard",
          "financialData",
          params,
        ],
      },
      schedule: {
        getAllScheduleServiceOrderHistory: (
          id: string,
          page: number,
          limit: number,
          remoteUtilityId: number,
          search?: string,
          status?: number,
          dateFrom?: string,
          dateTo?: string
        ): [
          ModuleType,
          EntityType,
          ActionType,
          string,

          number,
          number,
          number,
          string?,
          number?,
          string?,
          string?
        ] => [
          "ax",
          "schedule",
          "getAllScheduleServiceOrderHistory",
          id,
          page,
          limit,
          remoteUtilityId,
          search,
          status,
          dateFrom,
          dateTo,
        ],
        getAllScheduleAssets: (
          id: string,
          page: number,
          limit: number,
          remoteUtilityId: number,
          search?: string
        ): [
          ModuleType,
          EntityType,
          ActionType,
          string,
          number,
          number,
          number,
          string?
        ] => [
          "ax",
          "schedule",
          "getAllScheduleAssets",
          id,
          page,
          limit,
          remoteUtilityId,
          search,
        ],
        getScheduleById: (
          id: string
        ): [ModuleType, EntityType, ActionType, string] => [
          "ax",
          "schedule",
          "getScheduleById",
          id,
        ],
        getAllNetworks: (
          remoteUtilityId: number,
          page: number,
          limit: number,
          isPaginationRequired: number,
          searchData?: string,
          type?: string,
          area?: string
        ): [ModuleType, EntityType, ActionType, ...any[]] => [
          "ax",
          "schedule",
          "getAllNetworks",
          remoteUtilityId,
          page,
          limit,
          isPaginationRequired,
          searchData,
          type,
          area,
        ],
        getAllFacilities: (
          remoteUtilityId: number,
          page: number,
          limit: number,
          searchData?: string,
          type?: string,
          area?: string
        ): [ModuleType, EntityType, ActionType, ...any[]] => [
          "ax",
          "schedule",
          "getAllFacilities",
          remoteUtilityId,
          page,
          limit,
          searchData,
          type,
          area,
        ],
        getAllSystems: (
          remoteUtilityId: number,
          isPaginationRequired: number,
          searchData?: string,
          type?: string,
          area?: string,
          facility?: string
        ): [ModuleType, EntityType, ActionType, ...any[]] => [
          "ax",
          "schedule",
          "getAllSystems",
          remoteUtilityId,
          isPaginationRequired,
          searchData,
          type,
          area,
          facility,
        ],
        getAllSOPs: (
          remoteUtilityId: string,
          readingSource: string,
          searchData?: string,
          sopAssociationType?: string,
          operationType?: string,
          page?: number,
          limit?: number
        ): [ModuleType, EntityType, ActionType, ...any[]] => [
          "ax",
          "schedule",
          "getAllSOPs",
          remoteUtilityId,
          readingSource,
          searchData,
          sopAssociationType,
          operationType,
          page,
          limit,
        ],
        getChoices: (
          type: string
        ): [ModuleType, EntityType, ActionType, string] => [
          "ax",
          "schedule",
          "getChoices",
          type,
        ],
        getAllAssets: (
          remoteUtilityId: number,
          page: number,
          limit: number,
          searchData?: string,
          type?: string,
          area?: string,
          system?: string,
          network?: string,
          facility?: string
        ): [ModuleType, EntityType, ActionType, ...any[]] => [
          "ax",
          "schedule",
          "getAllAssets",
          remoteUtilityId,
          page,
          limit,
          searchData,
          type,
          area,
          system,
          network,
          facility,
        ],
        getDashboardData: (
          remoteUtilityId: number
        ): [ModuleType, EntityType, ActionType, number] => [
          "ax",
          "schedule",
          "getDashboardData",
          remoteUtilityId,
        ],
        getAllSchedules: (
          remoteUtilityId: number,
          page: number,
          limit: number,
          search?: string,
          status?: number,
          system_type?: string,
          criticality?: string
        ): [
          ModuleType,
          EntityType,
          ActionType,
          number,
          number,
          number,
          string?,
          number?,
          string?,
          string?
        ] => [
          "ax",
          "schedule",
          "getAllSchedules",
          remoteUtilityId,
          page,
          limit,
          search,
          status,
          system_type,
          criticality,
        ],
      },
      systemManagement: {
        getAllEnergyConsumptionHistory: (
          remoteUtilityId: string
        ): [ModuleType, EntityType, ActionType, string] => [
          "ax",
          "systemManagement",
          "getAllEnergyConsumptionHistory",
          remoteUtilityId,
        ],
        assets: {
          list: (
            remoteUtilityId: string,
            search: string,
            systemId: number,
            type: string,
            assetType: any
          ) => [
            "ax",
            "assets",
            "list",
            remoteUtilityId,
            search || "",
            systemId.toString(),
            type,
          ],
        },
        getAllAssets: (
          remoteUtilityId: number,
          page: number,
          limit: number,
          system: number,
          search: string
        ): [
          ModuleType,
          EntityType,
          ActionType,
          number,
          number,
          number,
          number,
          string
        ] => [
          "ax",
          "systemManagement",
          "getAllAssets",
          remoteUtilityId,
          page,
          limit,
          system,
          search,
        ],

        getSystemComplianceHistoryTabDataById: (
          entityType: number,
          id: number,
          remoteUtilityId: number
        ): [ModuleType, EntityType, ActionType, number, number, number] => [
          "ax",
          "systemManagement",
          "getSystemComplianceHistoryTabDataById",
          entityType,
          id,
          remoteUtilityId,
        ],

        getSystemComplianceTabDataById: (
          remoteUtilityId: number,
          id: number
        ): [ModuleType, EntityType, ActionType, number, number] => [
          "ax",
          "systemManagement",
          "getSystemComplianceTabDataById",
          remoteUtilityId,
          id,
        ],
        getFacilities: (
          remoteUtilityId: number,
          is_all_data: number
        ): [ModuleType, EntityType, ActionType, number, number] => [
          "ax",
          "systemManagement",
          "getFacilities",
          remoteUtilityId,
          is_all_data,
        ],
        getChoices: (
          type: string
        ): [ModuleType, EntityType, ActionType, string] => [
          "ax",
          "systemManagement",
          "getChoices",
          type,
        ],
        getAllSystems: (
          remoteUtilityId: number,
          isPaginationRequired: number,
          filters?: Record<string, any>
        ): [
          ModuleType,
          EntityType,
          ActionType,
          number,
          number,
          Record<string, any>
        ] => [
          "ax",
          "systemManagement",
          "getAllSystems",
          remoteUtilityId,
          isPaginationRequired,
          filters,
        ],
        getAllServiceOrder: (
          remoteUtilityId: number,
          id?: number,
          search?: string,
          pagination?: any
        ): [
          ModuleType,
          EntityType,
          ActionType,
          number,
          number,
          string,
          any
        ] => [
          "ax",
          "systemManagement",
          "getAllServiceOrder",
          remoteUtilityId,
          id,
          search,
          pagination,
        ],
        getDashboardData: (
          remoteUtilityId: number
        ): [ModuleType, EntityType, ActionType, number] => [
          "ax",
          "systemManagement",
          "getDashboardData",
          remoteUtilityId,
        ],
        getAllUserInfo: (
          remoteUtilityId: number,
          role: string
        ): [ModuleType, EntityType, ActionType, number, string] => [
          "ax",
          "systemManagement",
          "getAllUserInfo",
          remoteUtilityId,
          role,
        ],
        getSystemDataById: (
          id?: number
        ): [ModuleType, EntityType, ActionType, number] => [
          "ax",
          "systemManagement",
          "getSystemDataById",
          id,
        ],
        getAllSystemTabDataById: (
          id: number,
          tab_name: string,
          remoteUtilityId: number
        ): [ModuleType, EntityType, ActionType, number, string, number] => [
          "ax",
          "systemManagement",
          "getAllSystemTabDataById",
          id,
          tab_name,
          remoteUtilityId,
        ],
        getAllSystemAssetTabDataById: (
          id: number,
          tab_name: string,
          is_pagination_required?: number
        ): [ModuleType, EntityType, ActionType, number, string, number?] => [
          "ax",
          "systemManagement",
          "getSystemAssetTabDataById",
          id,
          tab_name,
          is_pagination_required,
        ],
        getAllUtilityServices: (
          remoteUtilityId: number,
          utility_service: string
        ): [ModuleType, EntityType, ActionType, number, string] => [
          "ax",
          "systemManagement",
          "getAllUtilityServices",
          remoteUtilityId,
          utility_service,
        ],
        getAllCriticality: (
          remoteUtilityId: number,
          show_inactive: boolean
        ): [ModuleType, EntityType, ActionType, number, boolean] => [
          "ax",
          "systemManagement",
          "getAllCriticality",
          remoteUtilityId,
          show_inactive,
        ],
        getSystemType: (
          remoteUtilityId: number,
          config_level?: string,
          show_inactive?: boolean
        ): [ModuleType, EntityType, ActionType, number, string?, boolean?] => [
          "ax",
          "systemManagement",
          "getSystemType",
          remoteUtilityId,
          config_level,
          show_inactive,
        ],
        systemParameters: (
          systemType: string
        ): [ModuleType, EntityType, ActionType, string, string] => [
          "ax",
          "systemManagement",
          "list",
          "system-parameters",
          systemType,
        ],
      },
      networks: {
        backupStatus: (): [ModuleType, "networks", "backupStatus"] => [
          "ax",
          "networks",
          "backupStatus",
        ],

        networkType: (): [ModuleType, "networks", "networkType"] => [
          "ax",
          "networks",
          "networkType",
        ],
        userInfo: (params: {
          remote_utility_id: any;
        }): [EntityType, "userInfo", any] => ["networks", "userInfo", params],
        networkSummary: (): [ModuleType, "networks", "networkSummary"] => [
          "ax",
          "networks",
          "networkSummary",
        ],
        networkDetails: (params: {
          networkId: string;
          tab: string;
        }): [EntityType, "networkDetails", any] => [
          "networks",
          "networkDetails",
          params,
        ],

        assetList: (params: {
          remote_utility_id: any;
          page: number;
          limit: number;
          network: any;
        }): [EntityType, "assetList", any] => ["networks", "assetList", params],
        serviceOrder: (params: {
          remote_utility_id: any;
          request_id: any;
        }): [EntityType, "networkDetails", any] => [
          "networks",
          "networkDetails",
          params,
        ],
        documents: (params?: {
          networkId: string;
        }): [EntityType, "documents", any] => ["networks", "documents", params],
        details: (params: {
          networkId: string;
        }): [EntityType, "networkDetails", any] => [
          "networks",
          "networkDetails",
          params,
        ],
        complianceOverview: (params: {
          remote_utility_id: any;
          entity_type: any;
          entity_id: any;
        }): [EntityType, "complianceOverview", any] => [
          "networks",
          "complianceOverview",
          params,
        ],

        complianceHistory: (params: {
          entity_type: any;
          entity_id: any;
        }): [EntityType, "complianceHistory", any] => [
          "networks",
          "complianceHistory",
          params,
        ],
        operationalStatus: (): [
          ModuleType,
          "networks",
          "operationalStatus"
        ] => ["ax", "networks", "operationalStatus"],
        originFacilities: (params: {
          remote_utility_id: number;
          is_all_data: any;
        }): [EntityType, "originFacilities", any] => [
          "networks",
          "originFacilities",
          params,
        ],
        networkList: (
          filters?: Record<string, any>
        ): [EntityType, "networkList", any] => [
          "networks",
          "networkList",
          filters,
        ],
        criticalityData: (params: {
          remote_utility_id: string;
          show_inactive: string;
        }): [EntityType, "criticalityData", any] => [
          "networks",
          "criticalityData",
          params,
        ],
        units: (params: {
          remote_utility_id: number;
          utility_service: string;
        }): [EntityType, "units", any] => ["networks", "units", params],
        territoryZones: (params: {
          remote_utility_id: number;
          show_inactive: boolean;
        }): [EntityType, "territoryZones", any] => [
          "networks",
          "territoryZones",
          params,
        ],
        territoryAreas: (params: {
          remote_utility_id: number;
          show_inactive: boolean;
        }): [EntityType, "territoryAreas", any] => [
          "networks",
          "territoryAreas",
          params,
        ],
        transmissionNetworks: (params: {
          remote_utility_id: number;
          is_pagination_required: number;
        }): [EntityType, "transmissionNetworks", any] => [
          "networks",
          "transmissionNetworks",
          params,
        ],
        dmaDistributionNetworks: (params: {
          remote_utility_id: number;
          is_pagination_required: number;
        }): [EntityType, "dmaDistributionNetworks", any] => [
          "networks",
          "dmaDistributionNetworks",
          params,
        ],
        distributionNetworks: (params: {
          remote_utility_id: number;
          is_pagination_required: number;
        }): [EntityType, "distributionNetworks", any] => [
          "networks",
          "distributionNetworks",
          params,
        ],
        destinationNetwork: (params: {
          type: string;
          remote_utility_id: number;
          is_pagination_required: number;
        }): [EntityType, "networksByType", any] => [
          "networks",
          "networksByType",
          params,
        ],
      },
      failures: {
        failuresDashboard: (params: {
          remote_utility_id: any;
        }): [EntityType, "failuresDashboard", any] => [
          "failures",
          "failuresDashboard",
          params,
        ],
        sopSelection: (params: {
          remote_utility_id: string;
          reading_source: string;
          association_type: string;
          operation_type: any;
        }): [EntityType, "sopSelection", any] => [
          "failures",
          "sopSelection",
          params,
        ],
        failureModes: (params: {
          remote_utility_id: string;
          asset_type_characteristics: any;
          config_level: any;
          code_list: any;
        }): [EntityType, "failureModes", any] => [
          "failures",
          "failureModes",
          params,
        ],
        observedSymptom: (): [ModuleType, "failures", "observedSymptom"] => [
          "ax",
          "failures",
          "observedSymptom",
        ],
        failureStatus: (): [ModuleType, "failures", "failureStatus"] => [
          "ax",
          "failures",
          "failureStatus",
        ],
        operationStatus: (): [ModuleType, "failures", "operationStatus"] => [
          "ax",
          "failures",
          "operationStatus",
        ],
        assetByMap: (params: {
          remote_utility_id: string;
          longitude: any;
          latitude: any;
        }): [EntityType, "failuresDashboard", any] => [
          "failures",
          "failuresDashboard",
          params,
        ],
        failuresList: (params: {
          remote_utility_id: any;
        }): [EntityType, "failuresList", any] => [
          "failures",
          "failuresList",
          params,
        ],
        assetList: (params: {
          remote_utility_id: any;
          page: any;
          limit: any;
        }): [EntityType, "failuresList", any] => [
          "failures",
          "failuresList",
          params,
        ],

        failuresDetails: (params: {
          remote_utility_id: any;
          id: any;
        }): [EntityType, "failuresDetails", any] => [
          "failures",
          "failuresDetails",
          params,
        ],
      },

      systemType: {
        deleteSystemType: (
          remoteUtilityId: number,
          code: string
        ): [ModuleType, EntityType, ActionType, number, string] => [
          "ax",
          "systemType",
          "deleteSystemType",
          remoteUtilityId,
          code,
        ],
        getAllSystemType: (
          remoteUtilityId: number,
          config_level?: string,
          show_inactive?: boolean
        ): [ModuleType, EntityType, ActionType, number, string?, boolean?] => [
          "ax",
          "systemType",
          "getAllSystemType",
          remoteUtilityId,
          config_level,
          show_inactive,
        ],
        searchSystemType: (
          remoteUtilityId: number,
          search_field?: string,
          search_data?: string
        ): [ModuleType, EntityType, ActionType, number, string?, string?] => [
          "ax",
          "systemType",
          "searchSystemType",
          remoteUtilityId,
          search_field,
          search_data,
        ],
        getAllSystemTypeParameter: (
          remoteUtilityId: number,
          config_level?: string,
          show_inactive?: boolean,
          code_list?: string
        ): [
          ModuleType,
          EntityType,
          ActionType,
          number,
          string?,
          boolean?,
          string?
        ] => [
          "ax",
          "systemType",
          "getAllSystemTypeParameter",
          remoteUtilityId,
          config_level,
          show_inactive,
          code_list,
        ],
      },
      manufacturer: {
        getAllAssetStatus: (): [ModuleType, EntityType, ActionType] => [
          "ax",
          "manufacturer",
          "getAllAssetStatus",
        ],
        getAllAssets: (
          remoteUtilityId: number,
          manufacturer_id: number,
          filters: any
        ): [ModuleType, EntityType, ActionType, number, number, any] => [
          "ax",
          "manufacturer",
          "getAllAssets",
          remoteUtilityId,
          manufacturer_id,
          filters,
        ],
        getAllManufacturer: (
          page: number,
          remoteUtilityId: number,
          search_data?: string,
          country?: string,
          status?: boolean
        ): [
          ModuleType,
          EntityType,
          ActionType,
          number,
          number,
          string?,
          string?,
          boolean?
        ] => [
          "ax",
          "manufacturer",
          "getAllManufacturer",
          page,
          remoteUtilityId,
          search_data,
          country,
          status,
        ],
        getCountry: (): [ModuleType, EntityType, ActionType] => [
          "ax",
          "manufacturer",
          "getCountry",
        ],
        getAssetType: (): [ModuleType, EntityType, ActionType] => [
          "ax",
          "manufacturer",
          "getAssetType",
        ],
        getManufacturerById: (
          remoteUtilityId: number,
          id: number
        ): [ModuleType, EntityType, ActionType, number, number] => [
          "ax",
          "manufacturer",
          "getManufacturerById",
          remoteUtilityId,
          id,
        ],
        getManufacturerSummary: (): [ModuleType, EntityType, ActionType] => [
          "ax",
          "manufacturer",
          "getManufacturerSummary",
        ],
      },
      facilities: facilitiesKeyFactory,
      serviceAndMangement: serviceAndMangement,
      facilityType: {
        facilityData: (params: {
          remote_utility_id: string;
          config_level: string;
          show_inactive: string;
        }): [EntityType, "facilityData", any] => [
          "facilityType",
          "facilityData",
          params,
        ],
        searchFacilityType: (params: {
          remote_utility_id: string;
        }): [EntityType, "searchFacilityType", any] => [
          "facilityType",
          "searchFacilityType",
          params,
        ],
      },
      networkType: {
        networkTypeData: (params: {
          remote_utility_id: string;
          config_level: string;
          show_inactive: string;
        }): [EntityType, "networkTypeData", any] => [
          "networkType",
          "networkTypeData",
          params,
        ],
        searchNetworkType: (params: {
          remote_utility_id: string;
        }): [EntityType, "searchFacilityType", any] => [
          "facilityType",
          "searchFacilityType",
          params,
        ],
      },

      criticalParameters: {
        list: (): [ModuleType, "criticalParameters", ActionType] => [
          "onboarding",
          "criticalParameters",
          "list",
        ],
        detail: (
          id: string
        ): [ModuleType, "criticalParameters", ActionType, string] => [
          "onboarding",
          "criticalParameters",
          "details",
          id,
        ],
        search: (
          query: string
        ): [ModuleType, "criticalParameters", ActionType, string] => [
          "onboarding",
          "criticalParameters",
          "search",
          query,
        ],
      },
      conditionParameters: {
        list: (): [ModuleType, "conditionParameters", ActionType] => [
          "onboarding",
          "conditionParameters",
          "list",
        ],
        detail: (
          id: string
        ): [ModuleType, "conditionParameters", ActionType, string] => [
          "onboarding",
          "conditionParameters",
          "details",
          id,
        ],
        search: (
          query: string
        ): [ModuleType, "conditionParameters", ActionType, string] => [
          "onboarding",
          "conditionParameters",
          "search",
          query,
        ],
      },
      settings: {
        assetClassList: (): [ModuleType, EntityType, ActionType, any] => [
          "ax",
          "settings",
          "list",
          "asset-class-list",
        ],
        assetTypeList: (
          code?: string
        ): [ModuleType, EntityType, ActionType, any, string] => [
          "ax",
          "settings",
          "list",
          "asset-type-list",
          code,
        ],
        allAssetTypes: (): [ModuleType, EntityType, ActionType, any] => [
          "ax",
          "settings",
          "list",
          "all-asset-types",
        ],
        assetDimensionList: (
          code?: string
        ): [ModuleType, EntityType, ActionType, string, string] => [
          "ax",
          "settings",
          "list",
          "asset-dimension-list",
          code,
        ],

        assetFailureList: (
          code?: string
        ): [ModuleType, EntityType, ActionType, any, string] => [
          "ax",
          "settings",
          "list",
          "asset-failure-list",
          code,
        ],

        assetTypeDimensionList: (
          params?: Record<string, any>
        ): [ModuleType, EntityType, ActionType, any, Record<string, any>] => [
          "ax",
          "settings",
          "list",
          "asset-type-dimension-list",
          params,
        ],

        assetSearchClassList: (
          searchData: string
        ): [ModuleType, EntityType, ActionType, any, string] => [
          "ax",
          "settings",
          "list",
          "asset-search-class-list",
          searchData,
        ],

        assetSearchTypeDimensionList: (
          searchData?: string
        ): [ModuleType, EntityType, ActionType, any, string] => [
          "ax",
          "settings",
          "list",
          "asset-type-dimension-list",
          searchData,
        ],
      },
      assets: {
        assetList: (
          queryParams?: Record<string, any>
        ): [ModuleType, EntityType, ActionType, any, Record<string, any>] => [
          "ax",
          "assets",
          "list",
          "asset-list",
          queryParams,
        ],
        assetDetail: (
          id?: string
        ): [ModuleType, EntityType, ActionType, string, string] => [
          "ax",
          "assets",
          "detail",
          "asset-detail",
          id,
        ],
        facilitiesList: (): [ModuleType, EntityType, ActionType, string] => [
          "ax",
          "assets",
          "detail",
          "facilities-list",
        ],
        systemNetworkList: (
          facilityId?: string
        ): [ModuleType, EntityType, ActionType, string, string] => [
          "ax",
          "assets",
          "detail",
          "system-network-detail",
          facilityId,
        ],
        assetStatusList: (): [ModuleType, EntityType, ActionType, string] => [
          "ax",
          "assets",
          "detail",
          "asset-status-list",
        ],
        depreciationMethodList: (): [
          ModuleType,
          EntityType,
          ActionType,
          string
        ] => ["ax", "assets", "detail", "depreciation-method-list"],
        manufactureOptions: (): [ModuleType, EntityType, ActionType, any] => [
          "ax",
          "assets",
          "list",
          "manufacture-options",
        ],
        assetOptions: (): [ModuleType, EntityType, ActionType, any] => [
          "ax",
          "assets",
          "list",
          "asset-options",
        ],
        assetDimensionFieldsList: (
          code?: string
        ): [ModuleType, EntityType, ActionType, string, string] => [
          "ax",
          "settings",
          "list",
          "asset-dimension-fields-list",
          code,
        ],
        assetCondition: (): [ModuleType, EntityType, ActionType, string] => [
          "ax",
          "assets",
          "list",
          "asset-condition",
        ],
        conditionAssessmentDetail: (
          id: string
        ): [ModuleType, EntityType, ActionType, string, string] => [
          "ax",
          "assets",
          "detail",
          "conditional-assessment-detail",
          id,
        ],
        performanceDetail: (
          id: string
        ): [ModuleType, EntityType, ActionType, string, string] => [
          "ax",
          "assets",
          "detail",
          "performance-detail",
          id,
        ],
        alertsDetail: (
          id: string
        ): [ModuleType, EntityType, ActionType, string, string] => [
          "ax",
          "assets",
          "detail",
          "alerts-detail",
          id,
        ],
        assetSummary: (): [ModuleType, EntityType, ActionType, string] => [
          "ax",
          "assets",
          "detail",
          "asset-summary",
        ],
        oAndM: (
          id?: string,
          search?: string
        ): [ModuleType, EntityType, ActionType, string, string, string] => [
          "ax",
          "assets",
          "detail",
          "o-and-m",
          id,
          search,
        ],
      },
      shared: {
        notesList: (
          type?: string,
          id?: string
        ): [ModuleType, EntityType, ActionType, string, string, string] => [
          "ax",
          "assets",
          "notes",
          "notes-list",
          id,
          type,
        ],
        activityLogList: (
          id?: string,
          type?: string
        ): [ModuleType, EntityType, ActionType, string, string, string] => [
          "ax",
          "assets",
          "getActivityLogs",
          "activity-log-list",
          id,
          type,
        ],
        priorityOptions: (): [ModuleType, EntityType, ActionType, string] => [
          "ax",
          "assets",
          "list",
          "priority-options",
        ],
        assetStatusOptions: (): [
          ModuleType,
          EntityType,
          ActionType,
          string
        ] => ["ax", "assets", "detail", "asset-status-options"],
        incidentStatusOptions: (): [
          ModuleType,
          EntityType,
          ActionType,
          string
        ] => ["ax", "assets", "detail", "incident-status-options"],
        facilitiesOptions: (): [ModuleType, EntityType, ActionType, string] => [
          "ax",
          "assets",
          "list",
          "facilities-options",
        ],
        networkOptions: (): [ModuleType, EntityType, ActionType, string] => [
          "ax",
          "assets",
          "list",
          "network-options",
        ],
        systemOptions: (): [ModuleType, EntityType, ActionType, string] => [
          "ax",
          "assets",
          "list",
          "system-options",
        ],
        assetTypeOptions: (): [ModuleType, EntityType, ActionType, string] => [
          "ax",
          "assets",
          "list",
          "asset-type-options",
        ],
        networkTypeOptions: (): [
          ModuleType,
          EntityType,
          ActionType,
          string
        ] => ["ax", "assets", "list", "network-type-options"],
        systemTypeOptions: (): [ModuleType, EntityType, ActionType, string] => [
          "ax",
          "assets",
          "list",
          "system-type-options",
        ],
        facilityTypeOptions: (): [
          ModuleType,
          EntityType,
          ActionType,
          string
        ] => ["ax", "assets", "list", "facility-type-options"],
        networkChoices: (): [ModuleType, EntityType, ActionType, string] => [
          "ax",
          "assets",
          "list",
          "network-choice-list",
        ],
        getAllSchedules: (
          entityId: string,
          entityType: string,
          remoteUtilityId: number,
          page: number,
          limit: number,
          search?: string,
          status?: number,
          system_type?: string,
          criticality?: string
        ): [
          ModuleType,
          EntityType,
          ActionType,
          string,
          string,
          number,
          number,
          number,
          string?,
          number?,
          string?,
          string?
        ] => [
          "ax",
          "schedule",
          "getAllSchedules",
          entityId,
          entityType,
          remoteUtilityId,
          page,
          limit,
          search,
          status,
          system_type,
          criticality,
        ],
        facilityChoices: (): [ModuleType, EntityType, ActionType, string] => [
          "ax",
          "assets",
          "list",
          "facility-choice-list",
        ],
        jobcardStatusChoices: (): [
          ModuleType,
          EntityType,
          ActionType,
          string
        ] => ["ax", "assets", "list", "jobcard-status-choices"],
      },
      incidents: {
        incidentsList: (
          queryParams?: Record<string, any>
        ): [
          ModuleType,
          EntityType,
          ActionType,
          string,
          Record<string, any>
        ] => ["ax", "assets", "list", "incidents-list", queryParams],
        assetsList: (
          queryParams: Record<string, any>
        ): [
          ModuleType,
          EntityType,
          ActionType,
          string,
          Record<string, any>
        ] => ["ax", "assets", "list", "assets-list", queryParams],
        incidentTypeOptions: (): [
          ModuleType,
          EntityType,
          ActionType,
          string
        ] => ["ax", "assets", "list", "incident-type-options"],
        incidentDetail: (
          id?: string
        ): [ModuleType, EntityType, ActionType, string, string] => [
          "ax",
          "assets",
          "detail",
          "incident-detail",
          id,
        ],
        incidentDashboard: (): [ModuleType, EntityType, ActionType, string] => [
          "ax",
          "assets",
          "detail",
          "incident-dashboard",
        ],
      },
    },
    cx: {
      communication: {
        communicationHistory: (
          id: string
        ): [ModuleType, EntityType, ActionType, string] => [
          "cx",
          "communication",
          "communicationHistory",
          id,
        ],
        callEntry: (
          id: string
        ): [ModuleType, EntityType, ActionType, string] => [
          "cx",
          "communication",
          "callEntry",
          id,
        ],
        callPurpose: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "communication",
          "callPurpose",
        ],
        callStatus: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "communication",
          "callStatus",
        ],
      },

      nscSettings: {
        documentType: (params: {
          remote_utility_id: string;
          config_level: string;
        }): [ModuleType, EntityType, ActionType, any] => [
          "cx",
          "nscSettings",
          "documentType",
          params,
        ],
        getAllAddressComponent: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "nscSettings",
          "getAllAddressComponent",
        ],
        getResponseTimeConfiguration: (): [
          ModuleType,
          EntityType,
          ActionType
        ] => ["cx", "nscSettings", "getResponseTimeConfiguration"],
      },
      operationalSLA: {
        disconnectionReasons: {
          get: (): [ModuleType, EntityType, ActionType] => [
            "cx",
            "operationalSLA",
            "getDisconnectionReasons",
          ],
          create: (): [ModuleType, EntityType, ActionType] => [
            "cx",
            "operationalSLA",
            "createDisconnectionReason",
          ],
          update: (): [ModuleType, EntityType, ActionType] => [
            "cx",
            "operationalSLA",
            "updateDisconnectionReason",
          ],
          delete: (): [ModuleType, EntityType, ActionType] => [
            "cx",
            "operationalSLA",
            "deleteDisconnectionReason",
          ],
        },
        reconnectionReasons: {
          get: (): [ModuleType, EntityType, ActionType] => [
            "cx",
            "operationalSLA",
            "getReconnectionReasons",
          ],
        },
        transferTypes: {
          get: (): [ModuleType, EntityType, ActionType] => [
            "cx",
            "operationalSLA",
            "getTransferTypes",
          ],
        },
      },
      selfService: {
        faqList: (params: {
          remote_utility_id: string;
          is_pagination_required: any;
          page: any;
          limit: any;
          show_inactive?: any;
        }): [EntityType, "faqList", any] => ["selfService", "faqList", params],
        dashboardDetails: (params: {
          remote_utility_id: string;
        }): [EntityType, "dashboardDetails", any] => [
          "selfService",
          "dashboardDetails",
          params,
        ],
        searchTips: (params: {
          remote_utility_id: string;
        }): [EntityType, "searchTips", any] => [
          "selfService",
          "searchTips",
          params,
        ],
        searchFAQ: (params: {
          remote_utility_id: string;
        }): [EntityType, "searchFAQ", any] => [
          "selfService",
          "searchFAQ",
          params,
        ],
        serviceCenterList: (params: {
          remote_utility_id: string;
          show_inactive?: boolean;
          page: number;
          limit: number;
        }): [EntityType, "serviceCenterList", any] => [
          "selfService",
          "serviceCenterList",
          params,
        ],
        serviceCenters: (params: {
          remote_utility_id: string;
        }): [EntityType, "serviceCenters", any] => [
          "selfService",
          "serviceCenters",
          params,
        ],
        city: (params: {
          remote_utility_id: string;
        }): [EntityType, "city", any] => ["selfService", "city", params],
        area: (params: {
          remote_utility_id: string;
          code_list: string;
        }): [EntityType, "area", any] => ["selfService", "area", params],
        subArea: (params: {
          remote_utility_id: string;
          code_list: string;
        }): [EntityType, "subArea", any] => ["selfService", "subArea", params],
        premise: (params: {
          remote_utility_id: string;
          code_list: string;
        }): [EntityType, "premise", any] => ["selfService", "premise", params],
        tipsData: (params: {
          remote_utility_id: string;
          is_pagination_required: any;
          page: any;
          limit: any;
          show_inactive?: any;
        }): [EntityType, "tipsData", any] => [
          "selfService",
          "tipsData",
          params,
        ],
        faqCategory: (params: {
          remote_utility_id: string;
        }): [EntityType, "faqCategory", any] => [
          "selfService",
          "faqCategory",
          params,
        ],
      },

      payment: {
        deleteChannel: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "payment",
          "deleteChannel",
        ],
        deleteMode: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "payment",
          "deleteMode",
        ],
        getAllPaymentFields: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "payment",
          "getAllPaymentFields",
        ],
        getMode: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "payment",
          "getMode",
        ],
        getAllFieldTypes: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "payment",
          "getAllFieldTypes",
        ],
        updateModeStatus: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "payment",
          "updateModeStatus",
        ],
        createMode: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "payment",
          "createMode",
        ],
        updateMode: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "payment",
          "updateMode",
        ],
        createChannel: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "payment",
          "createChannel",
        ],
        updateChannel: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "payment",
          "updateChannel",
        ],
        getChannel: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "payment",
          "getChannel",
        ],
        updateChannelStatus: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "payment",
          "updateChannelStatus",
        ],
      },
      utility: {
        utilityList: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "utilityServices",
          "list",
        ],
      },
      dashboard: {
        consumerSummary: (params: {
          remote_utility_id: any;
        }): [EntityType, "consumerSummary", any] => [
          "dashboard",
          "consumerSummary",
          params,
        ],
        revenueTrend: (params: {
          remote_utility_id: any;
        }): [EntityType, "revenueTrend", any] => [
          "dashboard",
          "revenueTrend",
          params,
        ],

        serviceTrend: (params: {
          remote_utility_id: any;
        }): [EntityType, "serviceTrend", any] => [
          "dashboard",
          "serviceTrend",
          params,
        ],

        consumptionUsage: (params: {
          remote_utility_id: any;
          utility_service: string;
        }): [EntityType, "consumptionUsage", any] => [
          "dashboard",
          "consumptionUsage",
          params,
        ],

        consumerCardDetail: (params: {
          remote_utility_id: any;
        }): [EntityType, "consumerCardDetail", any] => [
          "dashboard",
          "consumerCardDetail",
          params,
        ],

        outstandingSummary: (params: {
          remote_utility_id: any;
        }): [EntityType, "outstandingSummary", any] => [
          "dashboard",
          "outstandingSummary",
          params,
        ],

        monthlySupportSummary: (params: {
          remote_utility_id: any;
        }): [EntityType, "monthlySupportSummary", any] => [
          "dashboard",
          "monthlySupportSummary",
          params,
        ],
      },
      cxonboarding: {
        getNotes: (params: {
          remote_utility_id: any;
          request_id: string;
        }): [EntityType, "getNotes", any] => [
          "cxonboarding",
          "getNotes",
          params,
        ],
        consumerSummary: (params: {
          remoteUtilityId: any;
          activeTab: string;
        }): [EntityType, "consumerSummary", any] => [
          "cxonboarding",
          "consumerSummary",
          params,
        ],
        consumerList: (params: {
          remoteUtilityId: any;
          page: number;
          limit: number;
          searchData: string;
          status: string;
        }): [EntityType, "consumerList", any] => [
          "cxonboarding",
          "consumerList",
          params,
        ],
        consumerExport: (params: {
          remoteUtilityId: any;
          page: number;
          limit: number;
          searchData: string;
          status: string;
        }): [EntityType, "consumerExport", any] => [
          "cxonboarding",
          "consumerExport",
          params,
        ],
        serviceOrderConsumer: (params: {
          remote_utility_id: any;
          consumer_id: string;
          tab_name: string;
        }): [EntityType, "serviceOrderConsumer", any] => [
          "cxonboarding",
          "serviceOrderConsumer",
          params,
        ],
        serviceOrderConsumerforInstallation: (params: {
          remote_utility_id: any;
          consumer_id: string;
          tab_name: string;
        }): [EntityType, "serviceOrderConsumerforInstallation", any] => [
          "cxonboarding",
          "serviceOrderConsumerforInstallation",
          params,
        ],
        consumerMeter: (params: {
          remote_utility_id: any;
          consumer_id: string;
        }): [EntityType, "serviceOrderConsumer", any] => [
          "cxonboarding",
          "serviceOrderConsumer",
          params,
        ],
        consumerListHistory: (params: {
          remoteUtilityId: any;
          page: number;
          limit: number;
          searchData: string;
          status: string;
        }): [EntityType, "consumerListHistory", any] => [
          "cxonboarding",
          "consumerListHistory",
          params,
        ],
        consumerDocument: (params: {
          remote_utility_id: any;
          consumer_id: string;
        }): [EntityType, "consumerDocument", any] => [
          "cxonboarding",
          "consumerDocument",
          params,
        ],
        serviceOrder: (params: {
          remote_utility_id: any;
          search_data: string;
        }): [EntityType, "serviceOrder", any] => [
          "cxonboarding",
          "serviceOrder",
          params,
        ],
        serviceOrderByConsumer: (params: {
          remote_utility_id: any;
          consumer_id: string;
          tab_name: string;
        }): [EntityType, "serviceOrderByConsumer", any] => [
          "cxonboarding",
          "serviceOrderByConsumer",
          params,
        ],
        searchMeter: (params: {
          remote_utility_id: any;
          utility_service: any;
          premise: string;
          device_number?: any;
        }): [EntityType, "searchMeter", any] => [
          "cxonboarding",
          "searchMeter",
          params,
        ],
        status: (): [EntityType, "status"] => ["cxonboarding", "status"],
      },
      nsc: nscKeyFactory,
      serviceCategory: {
        create: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "serviceCategory",
          "create",
        ],
        update: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "serviceCategory",
          "update",
        ],
        status: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "serviceCategory",
          "status",
        ],
        delete: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "serviceCategory",
          "delete",
        ],
        list: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "serviceCategory",
          "list",
        ],
        search: (
          search_data?: string
        ): [ModuleType, EntityType, ActionType, string?] => [
          "cx",
          "serviceCategory",
          "search",
          search_data,
        ],
      },
      serviceSubCategory: {
        delete: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "serviceSubCategory",
          "delete",
        ],
        create: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "serviceSubCategory",
          "create",
        ],
        list: (
          code?: string
        ): [ModuleType, EntityType, ActionType, string?] => [
          "cx",
          "serviceSubCategory",
          "list",
          code,
        ],
      },
      complaintCategory: {
        create: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "complaintCategory",
          "create",
        ],
        status: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "complaintCategory",
          "status",
        ],
        update: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "complaintCategory",
          "update",
        ],
        list: (
          code?: string
        ): [ModuleType, EntityType, ActionType, string?] => [
          "cx",
          "complaintCategory",
          "list",
          code,
        ],
        search: (
          search_data?: string
        ): [ModuleType, EntityType, ActionType, string?] => [
          "cx",
          "complaintCategory",
          "search",
          search_data,
        ],
        delete: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "complaintCategory",
          "delete",
        ],
      },
      complaintSubCategory: {
        create: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "complaintSubCategory",
          "create",
        ],
        list: (
          code?: string
        ): [ModuleType, EntityType, ActionType, string?] => [
          "cx",
          "complaintCategory",
          "list",
          code,
        ],
        delete: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "complaintCategory",
          "delete",
        ],
      },
      serviceConfig: {
        category: {
          filter: (
            utility_service?: string[]
          ): [ModuleType, EntityType, ActionType, string[]?] => [
            "cx",
            "serviceCategory",
            "filter",
            utility_service,
          ],
        },

        priority: {
          filter: (): [ModuleType, EntityType, ActionType] => [
            "cx",
            "priority",
            "filter",
          ],
        },
        template: {
          filter: (): [ModuleType, EntityType, ActionType] => [
            "cx",
            "template",
            "filter",
          ],
        },
        availability: {
          filter: (): [ModuleType, EntityType, ActionType] => [
            "cx",
            "availability",
            "filter",
          ],
        },
        filter: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "serviceConfig",
          "filter",
        ],
        create: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "serviceConfig",
          "create",
        ],
        update: (
          service_id: number
        ): [ModuleType, EntityType, ActionType, number?] => [
          "cx",
          "serviceConfig",
          "update",
          service_id,
        ],
        list: (
          utility_service?: any[]
        ): [ModuleType, EntityType, ActionType, any?] => [
          "cx",
          "serviceConfig",
          "list",
          utility_service,
        ],
        search: (
          search_data?: string
        ): [ModuleType, EntityType, ActionType, string?] => [
          "cx",
          "serviceConfig",
          "search",
          search_data,
        ],
        delete: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "serviceConfig",
          "delete",
        ],
      },
      complaintConfig: {
        category: {
          filter: (
            utility_service?: string[]
          ): [ModuleType, EntityType, ActionType, string[]?] => [
            "cx",
            "complaintConfig",
            "filter",
            utility_service,
          ],
        },
        subCategory: {
          filter: (
            code_list?: string
          ): [ModuleType, EntityType, ActionType, string?] => [
            "cx",
            "complaintConfig",
            "filter",
            code_list,
          ],
        },
        severity: {
          filter: (): [ModuleType, EntityType, ActionType] => [
            "cx",
            "severity",
            "filter",
          ],
        },
        frequency: {
          filter: (): [ModuleType, EntityType, ActionType] => [
            "cx",
            "frequency",
            "filter",
          ],
        },
        list: (
          utility_service?: any[]
        ): [ModuleType, EntityType, ActionType, any?] => [
          "cx",
          "complaintConfig",
          "list",
          utility_service,
        ],
        search: (
          search_data?: string
        ): [ModuleType, EntityType, ActionType, string?] => [
          "cx",
          "complaintConfig",
          "search",
          search_data,
        ],
        create: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "complaintConfig",
          "create",
        ],
        update: (
          complaint_id: number
        ): [ModuleType, EntityType, ActionType, number?] => [
          "cx",
          "complaintConfig",
          "update",
          complaint_id,
        ],
        delete: (): [ModuleType, EntityType, ActionType] => [
          "cx",
          "complaintConfig",
          "delete",
        ],
      },
      utilityDashboard: (): [ModuleType, "utilityDashboard"] => [
        "onboarding",
        "utilityDashboard",
      ],
      utilityRevenue: (): [ModuleType, "utilityRevenue"] => [
        "onboarding",
        "utilityRevenue",
      ],
      customerService: (): [ModuleType, "customerService"] => [
        "onboarding",
        "customerService",
      ],

      workOrderService: (): [ModuleType, "workOrderService"] => [
        "onboarding",
        "workOrderService",
      ],
      userMgmtDashboard: (): [ModuleType, "userMgmtDashboard"] => [
        "onboarding",
        "userMgmtDashboard",
      ],
      userMgmtTable: (
        page: number = 1
      ): [ModuleType, "userMgmtTable", number] => [
        "onboarding",
        "userMgmtTable",
        page,
      ],
      departmentOptions: (): [ModuleType, "departmentOptions"] => [
        "onboarding",
        "departmentOptions",
      ],
      roleOptions: (): [ModuleType, "roleOptions"] => [
        "onboarding",
        "roleOptions",
      ],
      //  holidayList: (
      //   page?: number,
      //   limit?: number
      // ): [ModuleType, "holidayList", { page?: number; limit?: number }] => [
      //   "onboarding",
      //   "holidayList",
      //   { page, limit },
      // ],

      holidayList: (
        monthYear: string
      ): [ModuleType, "holidayList", { monthYear: string }] => [
        "onboarding",
        "holidayList",
        { monthYear },
      ],
      workingHourList: (): [ModuleType, "workingHourList"] => [
        "onboarding",
        "workingHourList",
      ],
      offlineQueue: (): [ModuleType, "offline", "queue"] => [
        "cx",
        "offline",
        "queue",
      ],
      // dashboard: (): [ModuleType, ActionType] => ["cx", "dashboard"],
      workorders: (
        filters?: any
      ): [ModuleType, EntityType, ActionType, any?] => [
        "cx",
        "workorder",
        "list",
        filters,
      ],
      complaints: complaintKeyFactory,
      serviceRequests: serviceRequestKeyFactory,
      consumers: consumerKeyFactory,
      outstanding: outstandingKeyFactory,
      payments: paymentsKeyFactory,
      disconnectionRequests: disconnectKeyFactory,
      reconnectionRequests: reconnectKeyFactory,
      transferRequests: transferKeyFactory,
    },

    callCenter: {
      performance: {
        summaryDashboard: (
          year: number,
          month: number
        ): [ModuleType, EntityType, ActionType, number, number] => [
          "callCenter",
          "performance",
          "summaryDashboard",
          year,
          month,
        ],
        consumerWeeklyReport: (): [ModuleType, EntityType, ActionType] => [
          "callCenter",
          "performance",
          "consumerWeeklyReport",
        ],
      },
      downloadBill: (
        billId: string
      ): [ModuleType, EntityType, ActionType, string] => [
        "callCenter",
        "downloadBill",
        "list",
        billId,
      ],
      allCallEntries: (): [ModuleType, EntityType, ActionType] => [
        "callCenter",
        "allCallEntries",
        "list",
      ],
      consumerSearchWithExtraInfo: (
        searchData: string
      ): [ModuleType, EntityType, ActionType, string] => [
        "callCenter",
        "consumerSearchWithExtraInfo",
        "list",
        searchData,
      ],
      consumerSearch: (): [ModuleType, EntityType, ActionType] => [
        "callCenter",
        "consumerSearch",
        "list",
      ],
      getConsumerBill: (
        consumerNumber: string
      ): [ModuleType, EntityType, ActionType, string] => [
        "callCenter",
        "getConsumerBill",
        "list",
        consumerNumber,
      ],
      callPurpose: (): [ModuleType, EntityType, ActionType] => [
        "callCenter",
        "callPurpose",
        "list",
      ],
      callStatus: (): [ModuleType, EntityType, ActionType] => [
        "callCenter",
        "callStatus",
        "list",
      ],
      summaryDashboard: (): [ModuleType, EntityType, ActionType] => [
        "callCenter",
        "summaryDashboard",
        "list",
      ],
    },

    bx: {
      calculations: (): [ModuleType, "calculations"] => ["bx", "calculations"],
      billing: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
        "bx",
        "billing",
        "list",
        filters,
      ],
      singleBillGeneration: {
        consumerList: (): [ModuleType, ActionType] => ["bx", "list"],
        billTemplates: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "bill-template-list",
        ],
        billingMeters: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "bill-meters",
        ],
        billData: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "details",
          "bill-data",
        ],
        consumerCreditNote: (): [ModuleType, ActionType] => ["bx", "details"],
        consumerDetails: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "details",
          "consumer-details",
        ],
        consumerLatestBill: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "details",
          "consumer-latest-bill",
        ],
        planData: (): [ModuleType, ActionType] => ["bx", "details"],
        meterData: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "billing-meter-data",
        ],
        meterReadingStatus: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "meter-reading-status",
        ],
        billDetails: (): [ModuleType, ActionType] => ["bx", "details"],
      },
      bulkBillGeneration: {
        utilityServiceList: (): [ModuleType, ActionType] => ["bx", "list"],
        categoryList: (): [ModuleType, ActionType] => ["bx", "details"],
        subCategoryList: (): [ModuleType, ActionType] => ["bx", "details"],
        areaList: (): [ModuleType, ActionType] => ["bx", "list"],
        subAreaList: (): [ModuleType, ActionType] => ["bx", "list"],
        premiseList: (): [ModuleType, ActionType] => ["bx", "list"],
        billCycleList: (): [ModuleType, ActionType] => ["bx", "list"],
        consumerCount: (): [ModuleType, ActionType] => ["bx", "details"],
        billCycleDetails: (): [ModuleType, ActionType] => ["bx", "details"],
        planDashboard: (): [ModuleType, ActionType] => ["bx", "dashboard"],
        consumerListViewData: (): [
          ModuleType,
          EntityType,
          ActionType,
          any?
        ] => ["bx", "billing", "list", "consumer-list-view-data"],
        consumerDashboard: (): [ModuleType, ActionType] => ["bx", "list"],
        consumerListMissingPlan: (): [
          ModuleType,
          EntityType,
          ActionType,
          any?
        ] => ["bx", "billing", "list", "consumer-missing-plan"],
        consumerMissingTariff: (): [
          ModuleType,
          EntityType,
          ActionType,
          any?
        ] => ["bx", "billing", "list", "consumer-missing-tariff"],

        plansList: (): [ModuleType, ActionType] => ["bx", "list"],
        ratesList: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "rat",
        ],
        outstandingBills: (): [ModuleType, ActionType] => ["bx", "details"],
        outstandingSummary: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "details",
          "outstanding-summary",
        ],

        meterReading: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "meter-reading",
        ],
        meterTypeChoices: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "meter",
          "list",
          "meter-type-choices",
        ],
        meterReadingMissing: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "meter",
          "list",
          "meter-reading-missing",
        ],
        meterReadingPendingValidation: (): [
          ModuleType,
          EntityType,
          ActionType,
          any?
        ] => ["bx", "meter", "list", "meter-reading-pending-validation"],
        meterDashboard: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "meter",
          "dashboard",
          "billing-meter-dashboard",
        ],
        downLoadFailedList: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "details",
          "failed-list-download",
        ],
        billGenerationSummary: (): [
          ModuleType,
          EntityType,
          ActionType,
          any?
        ] => ["bx", "billing", "details", "bill-generation-summary"],

        billData: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "details",
          "bill-data",
        ],

        billTemplates: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "details",
          "bill-templates",
        ],
        bulkBillData: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "details",
          "bulk-bill-data",
        ],
      },
      billCycle: {
        billCycleList: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "billing-cycle-list",
        ],
        exportList: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "billing-cycle-export",
        ],
        billCycleDashboard: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "details",
          "bill-cycle-dashboard",
        ],
        billCycleDetails: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "details",
          "bill-cycle-details",
        ],
        billCycleDetailsEdit: (): [
          ModuleType,
          EntityType,
          ActionType,
          any?
        ] => ["bx", "billing", "details", "bill-cycle-details-Edit"],
        cycleWiseRunList: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "cycle-wise-run",
        ],
        monthlyStats: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "details",
          "monthly-stats",
        ],
        premiseList: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "premise-list",
        ],
        category: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "category",
        ],
        subCategory: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "sub-category",
        ],
        consumerList: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "consumer-list",
        ],
        summary: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "dashboard",
          "summary",
        ],
        areaList: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "area-list",
        ],
        subAreaList: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "area-list",
        ],
      },
      billMaster: {
        billSummary: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "details",
          "bill-summary",
        ],
        billList: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "bill-list",
        ],
        exportList: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "bill-list-export",
        ],
        billCycleFrequency: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "bill-cycle-frequency",
        ],
        premiseList: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "premise-list-options",
        ],
        billCycle: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "details",
          "bill-master-cycle-list",
        ],
        billCycleOptions: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "details",
          "bill-cycle-options-list",
        ],
      },
      printingDistribution: {
        distributionList: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "distribution-list",
        ],
        exportList: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "distribution-list-export",
        ],

        printList: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "print-list",
        ],
        consumerList: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "consumer-list",
        ],
        consumerListSummary: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "details",
          "consumer-list-details",
        ],
        printSummary: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "details",
          "print-summary",
        ],
        paperBillList: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "paper-bill-list-details",
        ],
        paperBillListSummary: (): [
          ModuleType,
          EntityType,
          ActionType,
          any?
        ] => ["bx", "billing", "details", "paper-list-summary"],
        vendorList: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "vendor-options-list",
        ],
        distributionSummary: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "summary",
          "distribution-summary",
        ],
      },
      glCode: {
        glCodeList: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "gl-code-list",
        ],
        utilityServiceList: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "utility-service-list",
        ],
        summary: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "details",
          "summary",
        ],
      },
      dashboard: {
        summaryData: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "details",
          "summary-data",
        ],
        dashboard: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "dashboard",
          "dashboard-data",
        ],

        billCycleList: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "bill-cycle-list",
        ],
      },
      billTemplate: {
        template: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "details",
          "bill-template",
        ],
        summary: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "details",
          "template-summary",
        ],
        templateList: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "template-list",
        ],
        templateOptions: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "bill-template-options",
        ],
      },
      canvasTemplate: {
        template: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "details",
          "canvas-template",
        ],
        details: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "details",
          "canvas-template-details",
        ],
      },
      billHistory: {
        singleBill: (
          queryParams?: Record<string, any>
        ): [ModuleType, EntityType, ActionType, any, any?] => [
          "bx",
          "billing",
          "list",
          "single-bill-history",
          queryParams,
        ],
        billCycle: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "bulk-bill-history",
        ],
        singleBillDraft: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "single-bill-draft-history",
        ],
        historySummary: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "summary",
          "history-summary",
        ],
        BulkBillDraft: (): [ModuleType, EntityType, ActionType, any?] => [
          "bx",
          "billing",
          "list",
          "bulk-bill-draft-history",
        ],
      },
    },
    communication: {
      overview: (): [EntityType, ActionType] => [
        "communicationOverview",
        "list",
      ],
      listsOverview: (): [EntityType, ActionType] => [
        "communicationListOverview",
        "list",
      ],
      channelStat: (): [EntityType, ActionType] => [
        "communicationChannelStats",
        "list",
      ],
      channelPerformance: (): [EntityType, ActionType] => [
        "communicationChannelPerformance",
        "list",
      ],
      workflowPerformance: (): [EntityType, ActionType] => [
        "communicationWorkflowPerformance",
        "list",
      ],
      workflowStats: (): [EntityType, ActionType] => [
        "communicationWorkflowStats",
        "list",
      ],
      recipientType: (): [EntityType, ActionType] => [
        "communicationRecipientType",
        "list",
      ],
      recipientList: (): [EntityType, ActionType] => [
        "communicationRecipientList",
        "list",
      ],
      recipientEdit: (): [EntityType, ActionType] => [
        "communicationRecipientListEdit",
        "list",
      ],
      channelType: (): [EntityType, ActionType] => [
        "communicationChannelType",
        "list",
      ],
      templatesFilter: (
        channelType: string,
        categoryFilter: string,
        isDraft: boolean,
        tagFilter: string,
        searchData?: string
      ) => [
        "communicationTemplates",
        "list",
        channelType,
        categoryFilter,
        isDraft,
        tagFilter,
        searchData,
      ],
      templates: (): [EntityType, ActionType] => [
        "communicationTemplates",
        "list",
      ],
      templateUse: (utilityId: string, channelType: string) => [
        "communicationTemplatesUse",
        "list",
        utilityId,
        channelType,
      ],
      contactList: (): [EntityType, ActionType] => [
        "communicationContactList",
        "list",
      ],
      contactPreview: (): [EntityType, ActionType] => [
        "communicationContactPreview",
        "list",
      ],
      categoryConfig: (): [EntityType, ActionType] => [
        "communicationCategoryConf",
        "list",
      ],
      territoryConfig: (): [EntityType, ActionType] => [
        "communicationTerritoryConfig",
        "list",
      ],
      contactsWithTerritoryFilter: (): [EntityType, ActionType] => [
        "communicationContactsWithTerritoryFilter",
        "list",
      ],
      contactsWithCategoryFilter: (): [EntityType, ActionType] => [
        "communicationContactsWithCategoryFilter",
        "list",
      ],
      staticAllContacts: (): [EntityType, ActionType] => [
        "communicationStaticAllContacts",
        "list",
      ],
      workflows: (): [EntityType, ActionType] => [
        "communicationWorkflow",
        "list",
      ],

      workflowsDraft: (): [EntityType, ActionType] => [
        "communicationWorkflowDraft",
        "list",
      ],
      workflowsActive: (): [EntityType, ActionType] => [
        "communicationWorkflowActive",
        "list",
      ],
      workflowsAll: (): [EntityType, ActionType] => [
        "communicationWorkflowAll",
        "list",
      ],
      workflowRuns: (): [EntityType, ActionType] => [
        "communicationWorkflowRun",
        "list",
      ],
      workflowNotifications: (): [EntityType, ActionType] => [
        "communicationWorkflowNotifications",
        "list",
      ],
      workflowStat: (): [EntityType, ActionType] => [
        "communicationWorkflowStat",
        "list",
      ],
      notificationHistory: (pageNumber: number) => [
        "communicationNotificationHistory",

        "list",
        pageNumber,
      ],
      notificationDetails: (): [EntityType, ActionType] => [
        "communicationNotificationDetails",
        "list",
      ],
      // In your QueryKeyFactory
      placeHolders: (category: string) => [
        "communicationPlaceHolders",
        "list",
        category,
      ],
      placeHolderGroups: (): [EntityType, ActionType] => [
        "communicationPlaceHoldersGroups",
        "list",
      ],
      eventType: (): [EntityType, ActionType] => [
        "communicationEventType",
        "list",
      ],
      notificationHistoryFilter: (
        page?: number,
        channelTypeFilter?: string,
        statusDisplayFilter?: string[],
        searchData?: string
      ) => [
        "communicationHistoryFilter",
        "list",
        page,
        channelTypeFilter,
        statusDisplayFilter,
        searchData,
      ],
    },

    ux: {
      choices: (choice): ["choice", ActionType, string] => [
        "choice",
        "list",
        choice,
      ],
      history: historyKeyFactory,
      workflow: workflowKeyFactory,
      template: templateKeyFactory,

      messaging: messagingKeyFactory,
      lists: listsKeyFactory,
    },

    wx: {
      fieldForce: {
        getSkills: (): [ModuleType, EntityType, ActionType] => [
          "wx",
          "fieldForce",
          "getSkills",
        ],
        getCertificates: (): [ModuleType, EntityType, ActionType] => [
          "wx",
          "fieldForce",
          "getCertificates",
        ],
        getAreas: (): [ModuleType, EntityType, ActionType] => [
          "wx",
          "fieldForce",
          "getAreas",
        ],
        getSubAreas: (code_list: any[]) => [
          "wx",
          "fieldForce",
          "getSubAreas",
          code_list,
        ],
        getList: () => ["wx", "fieldForce", "list"],
        updateStatus: (): [ModuleType, EntityType, ActionType] => [
          "wx",
          "fieldForce",
          "updateStatus",
        ],
        updateFieldForce: (): [ModuleType, EntityType, ActionType] => [
          "wx",
          "fieldForce",
          "updateFieldForce",
        ],
        summary: (): [ModuleType, EntityType, ActionType] => [
          "wx",
          "fieldForce",
          "summary",
        ],
        view: {
          getDetails: (ffId): [ModuleType, EntityType, ActionType, any] => [
            "wx",
            "fieldForce",
            "getDetails",
            ffId
          ],
          getAssignments: (
            ff_no: string
          ): [ModuleType, EntityType, ActionType, string] => [
            "wx",
            "fieldForce",
            "getAssignments",
            ff_no,
          ],
          getTransactions: (
            ff_no: string,
            page: number
          ): [ModuleType, EntityType, ActionType, string, number] => [
            "wx",
            "fieldForce",
            "getTransactions",
            ff_no,
            page,
          ],
          getActivityLogs: (
            ff_id: string
          ): [ModuleType, EntityType, ActionType, string] => [
            "wx",
            "fieldForce",
            "getActivityLogs",
            ff_id,
          ],
          getAllCertificates: (
            ff_id: string
          ): [ModuleType, EntityType, ActionType, string] => [
            "wx",
            "fieldForce",
            "getAllCertificates",
            ff_id,
          ],
          getAllSkills: (
            ff_id: string
          ): [ModuleType, EntityType, ActionType, string] => [
            "wx",
            "fieldForce",
            "getAllSkills",
            ff_id,
          ],
          getAllAvailability: (): [ModuleType, EntityType, ActionType] => [
            "wx",
            "fieldForce",
            "getAllAvailability",
          ],
        },
      },
      dashboard: {
        dashboardOverview: (params: {
          remote_utility_id: any;
        }): [EntityType, "dashboardOverview", any] => [
          "dashboard",
          "dashboardOverview",
          params,
        ],
        dashboardServiceOrders: (params: {
          remote_utility_id: any;
          days: string;
        }): [EntityType, "dashboardServiceOrders", any] => [
          "dashboard",
          "dashboardServiceOrders",
          params,
        ],
        dashboardSlaPerformance: (params: {
          remote_utility_id: any;
        }): [EntityType, "dashboardSlaPerformance", any] => [
          "dashboard",
          "dashboardSlaPerformance",
          params,
        ],
        dashboardSopBySource: (params: {
          remote_utility_id: any;
          days: string;
        }): [EntityType, "dashboardSopBySource", any] => [
          "dashboard",
          "dashboardSopBySource",
          params,
        ],
        dashboardSopCost: (params: {
          remote_utility_id: any;
        }): [EntityType, "dashboardSopCost", any] => [
          "dashboard",
          "dashboardSopCost",
          params,
        ],
        dashboardRecentJobCards: (params: {
          utilityId: any;
          status?: string;
          limit?: number;
        }): [EntityType, "dashboardRecentJobCards", any] => [
          "dashboard",
          "dashboardRecentJobCards",
          params,
        ],
      },
      dispatcher: {
        serviceAssociations: () => ["wx", "association"],
        territoryConfig: () => ["wx", "area"],
        pendingSummary: () => ["wx", "job-card", "pending", "summary"],
        assignedSummary: () => ["wx", "job-card", "assigned", "summary"],
        completedSummary: () => ["wx", "job-card", "completed", "summary"],
        historySummary: () => ["wx", "job-card", "history", "summary"],
        pending: (): [EntityType, ActionType] => ["wxPending", "list"],
        assigned: (): [EntityType, ActionType] => ["wxAssigned", "list"],
        complete: (): [EntityType, ActionType] => ["wxComplete", "list"],
        history: (): [EntityType, ActionType] => ["wxHistory", "list"],
        details: (value: string): [EntityType, ActionType, any] => [
          "wxSODetails",
          "list",
          value,
        ],
        recommendation: (): [EntityType, ActionType] => [
          "wxRecommendation",
          "list",
        ],
        serviceProcedures: (): [EntityType, ActionType] => [
          "wxServiceProcedures",
          "list",
        ],
        activeServiceProcedures: (): [EntityType, ActionType] => [
          "wxActiveServiceProcedures",
          "list",
        ],
        serviceProceduresByType: (): [EntityType, ActionType] => [
          "wxServiceProceduresByType",
          "list",
        ],
        serviceProceduresByAssociation: (): [EntityType, ActionType] => [
          "wxServiceProceduresByAssociation",
          "list",
        ],
        serviceProcedureDetail: (): [EntityType, ActionType] => [
          "wxServiceProcedureDetail",
          "list",
        ],
        consumerList: (): [EntityType, ActionType] => [
          "wxConsumerList",
          "list",
        ],
        meterList: (): [EntityType, ActionType] => ["wxMeterList", "list"],
        fieldForceRecommend: (): [EntityType, ActionType] => [
          "wxFieldForceRecommend",
          "list",
        ],

        rejectionReason: (): [ModuleType, "dispatcher", "rejectionReason"] => [
          "wx",
          "dispatcher",
          "rejectionReason",
        ],
        priorityData: (): [ModuleType, "dispatcher", "priorityData"] => [
          "wx",
          "dispatcher",
          "priorityData",
        ],
        rejectedSO: (params: {
          remote_utility_id: any;
          is_rejected: string;
          page: any;
          limit: any;
        }): [EntityType, "rejectedSO", any] => [
          "dispatcher",
          "rejectedSO",
          params,
        ],
        rejectedSODetail: (params: {
          remote_utility_id: any;
          id: string;
        }): [EntityType, "rejectedSODetail", any] => [
          "dispatcher",
          "rejectedSODetail",
          params,
        ],
        rejectedSummary: (params: {
          remote_utility_id: any;
        }): [EntityType, "rejectedSummary", any] => [
          "dispatcher",
          "rejectedSummary",
          params,
        ],
      },
      settings: {
        types: (): [EntityType, ActionType] => ["wxTypes", "list"],
        subTypes: (): [EntityType, ActionType] => ["wxSubTypes", "list"],
        slaRules: (): [EntityType, ActionType] => ["wxSlaRules", "list"],
        taxRates: (): [EntityType, ActionType] => ["wxTaxRates", "list"],
        certifications: (): [EntityType, ActionType] => [
          "certifications",
          "list",
        ],
        skills: (): [EntityType, ActionType] => ["wxSkills", "list"],
        roles: (): [EntityType, ActionType] => ["wxRoles", "list"],
        rates: (): [EntityType, ActionType] => ["wxRates", "list"],
        pPEEquipment: (): [EntityType, ActionType] => [
          "wxPPEEquipment",
          "list",
        ],
        safetyPackage: (): [EntityType, ActionType] => [
          "wxSafetyPackage",
          "list",
        ],
        safetyProtocol: (): [EntityType, ActionType] => [
          "wxSafetyProtocol",
          "list",
        ],
        settingTask: (): [EntityType, ActionType] => ["settingTask", "list"],
        settingMaterial: (): [EntityType, ActionType] => [
          "settingMaterial",
          "list",
        ],
        settingReading: (): [EntityType, ActionType] => [
          "settingReading",
          "list",
        ],
        settingOperationTypes: (): [EntityType, ActionType] => [
          "settingOperationType",
          "list",
        ],
      },
      master: {
        activityLogs: (sopId: string, page?: number, limit?: number) => [
          "activity-logs",
          sopId,
          page || 1,
          limit || 10,
        ],
        serviceProcedureSummary: (): [EntityType, ActionType] => [
          "wxServiceProcedureSummary",
          "list",
        ],

        taxRates: (utilityId: string): [EntityType, ActionType, string] => [
          "wxTaxRates",
          "list",
          utilityId,
        ],

        // SOP Details keys
        sopMasterDetails: (id: string): [ModuleType, "sop-details", string] => [
          "wx",
          "sop-details",
          id,
        ],

        sopTabDetails: (
          fieldName: string
        ): [ModuleType, "sop-tab-details", string] => [
          "wx",
          "sop-tab-details",
          fieldName,
        ],

        // SOP Notes
        sopNotes: (sopId: string): [ModuleType, "sop-notes", string] => [
          "wx",
          "sop-notes",
          sopId,
        ],

        // SOP Templates
        sopTemplates: (
          status: boolean,
          filters?: Partial<sopFilters>
        ): [ModuleType, "sop-templates", boolean, Partial<sopFilters>?] => [
          "wx",
          "sop-templates",
          status,
          filters,
        ],

        // Alternative shorter version for templates
        sopTemplatesShort: (
          utilityId: string,
          isDraft: boolean
        ): [ModuleType, "sop-templates", string, boolean] => [
          "wx",
          "sop-templates",
          utilityId,
          isDraft,
        ],

        // Service Associations
        serviceAssociations: (
          utilityId: string
        ): [EntityType, ActionType, string] => [
          "serviceAssociations",
          "list",
          utilityId,
        ],

        // Utility Services
        utilityServices: (
          utilityId: string
        ): [EntityType, ActionType, string] => [
          "utilityServices",
          "list",
          utilityId,
        ],

        // SOP Configuration
        sopTypes: (utilityId: string): [EntityType, ActionType, string] => [
          "sopTypes",
          "list",
          utilityId,
        ],

        sopSubtypes: (
          utilityId: string,
          typeCode: string
        ): [EntityType, ActionType, string, string] => [
          "sopSubtypes",
          "list",
          utilityId,
          typeCode,
        ],

        // SOP Tasks
        sopTasks: (
          utilityId: string,
          operationType: string
        ): [EntityType, ActionType, string, string] => [
          "sopTasks",
          "list",
          utilityId,
          operationType,
        ],

        // SOP Materials
        sopMaterials: (
          utilityId: string,
          operationType: string
        ): [EntityType, ActionType, string, string] => [
          "sopMaterials",
          "list",
          utilityId,
          operationType,
        ],

        // SOP Readings
        sopReadings: (
          utilityId: string,
          operationType: string
        ): [EntityType, ActionType, string, string] => [
          "sopReadings",
          "list",
          utilityId,
          operationType,
        ],

        // SOP Edit Details
        sopEditDetails: (sopId: string): [EntityType, ActionType, string] => [
          "sopEditDetails",
          "details",
          sopId,
        ],
        sopDetails: (): [EntityType, ActionType] => ["wxSopDetails", "list"],
        operationTypes: (): [EntityType, ActionType] => [
          "wxOperationTypes",
          "list",
        ],
      },
    },
    shared:{
  dashboard:{
    dashboardData:  ( 
      tenantId: string,
      dashboardParameter: string,
      utilityId: string
      ): [EntityType, "dashboardData", any] => [
          "dashboard",
          "dashboardData",
          { tenantId, dashboardParameter, utilityId }
        ],

  }

},

    core: {
      sessions: (): [EntityType, ActionType] => ["sessions", "list"],
    },
    ix: {
      payments: paymentKeyFactory,
    },
    // Add other modules as needed
  };

  // Utility methods
  static isGlobalKey(queryKey: unknown[]): boolean {
    if (!Array.isArray(queryKey) || queryKey.length === 0) return false;

    const globalEntities: EntityType[] = [
      "user",
      "organization",
      "meter",
      "workorder",
      "utility",
    ];
    return globalEntities.includes(queryKey[0] as EntityType);
  }

  static getEntityFromKey(queryKey: unknown[]): EntityType | null {
    if (!Array.isArray(queryKey) || queryKey.length === 0) return null;
    return queryKey[0] as EntityType;
  }

  static getModuleFromKey(queryKey: unknown[]): ModuleType | null {
    if (!Array.isArray(queryKey) || queryKey.length === 0) return null;
    const modules: ModuleType[] = [
      "auth",
      "onboarding",
      "cx",
      "bx",
      "ax",
      "mx",
      "wx",
      "rx",
    ];
    if (modules.includes(queryKey[0] as ModuleType)) {
      return queryKey[0] as ModuleType;
    }
    return null;
  }
}
